function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function form$Y (ctx) {
  var __t,
    __p = '';
  if (ctx.mode.autocomplete) {
    __p += '\n  <div class="address-autocomplete-container">\n    <input\n      ref="' + ((__t = ctx.ref.searchInput) == null ? '' : __t) + '"\n      ';
    for (var attr in ctx.inputAttributes) {
      __p += '\n        ' + ((__t = attr) == null ? '' : __t) + '="' + ((__t = ctx.inputAttributes[attr]) == null ? '' : __t) + '"\n      ';
    }
    __p += '\n      value="' + ((__t = ctx.displayValue) == null ? '' : __t) + '"\n      autocomplete="off"\n      aria-label="' + ((__t = ctx.t('autocomplete')) == null ? '' : __t) + '"\n    >\n    ';
    if (!ctx.component.disableClearIcon) {
      __p += '\n      <i\n        class="address-autocomplete-remove-value-icon fa fa-times"\n        tabindex="' + ((__t = ctx.inputAttributes.tabindex) == null ? '' : __t) + '"\n        ref="' + ((__t = ctx.ref.removeValueIcon) == null ? '' : __t) + '"\n      ></i>\n    ';
    }
    __p += '\n  </div>\n';
  }
  __p += '\n';
  if (ctx.self.manualModeEnabled) {
    __p += '\n  <div class="form-check checkbox">\n    <label class="form-check-label">\n      <input\n        ref="' + ((__t = ctx.ref.modeSwitcher) == null ? '' : __t) + '"\n        type="checkbox"\n        class="form-check-input"\n        tabindex="' + ((__t = ctx.inputAttributes.tabindex) == null ? '' : __t) + '"\n        ';
    if (ctx.mode.manual) {
      __p += 'checked=true';
    }
    __p += '\n        ';
    if (ctx.disabled) {
      __p += 'disabled=true';
    }
    __p += '\n      >\n      <span>' + ((__t = ctx.component.switchToManualModeLabel) == null ? '' : __t) + '</span>\n    </label>\n  </div>\n';
  }
  __p += '\n';
  if (ctx.self.manualMode) {
    __p += '\n  <div ref="' + ((__t = ctx.nestedKey) == null ? '' : __t) + '">\n    ' + ((__t = ctx.children) == null ? '' : __t) + '\n  </div>\n';
  }
  __p += '\n';
  return __p;
}

var address = {
  form: form$Y
};

function form$X (ctx) {
  var __t,
    __p = '';
  __p += '<div\n  ';
  for (var attr in ctx.attrs) {
    __p += '\n    ' + ((__t = attr) == null ? '' : __t) + '="' + ((__t = ctx.attrs[attr]) == null ? '' : __t) + '"\n  ';
  }
  __p += '\n>\n  ' + ((__t = ctx.message) == null ? '' : __t) + '\n  ';
  if (ctx.options.vpat) {
    __p += '\n    <span class="sr-only" id="hotkey-i-' + ((__t = ctx.form._id) == null ? '' : __t) + '">' + ((__t = ctx.t('errorListHotkey')) == null ? '' : __t) + '</span>\n  ';
  }
  __p += '\n</div>\n';
  return __p;
}

var alert = {
  form: form$X
};

function form$W (ctx) {
  var __t,
    __p = '';
  __p += '<div class="formio builder grid grid-cols-12 gap-4 formbuilder">\n  <div class="col-span-12 xs:col-span-4 sm:col-span-3 md:col-span-2 formcomponents">\n    ' + ((__t = ctx.sidebar) == null ? '' : __t) + '\n  </div>\n  <div class="col-span-12 xs:col-span-8 sm:col-span-9 md:col-span-10 formarea" ref="form">\n    ' + ((__t = ctx.form) == null ? '' : __t) + '\n  </div>\n</div>\n';
  return __p;
}

var builder$2 = {
  form: form$W
};

function form$V (ctx) {
  var __t,
    __p = '';
  __p += '<div class="builder-component" ref="dragComponent">\n  ';
  if (!ctx.disableBuilderActions) {
    __p += '\n    <div class="component-btn-group" data-noattach="true">\n      <button\n        role="button"\n        aria-label="Remove button. Click to remove component from the form"\n        tabindex="-1"\n        class="btn btn-xxs btn-danger component-settings-button component-settings-button-remove"\n        ref="removeComponent"\n      >\n        <i class="' + ((__t = ctx.iconClass('remove')) == null ? '' : __t) + '"></i>\n      </button>\n      <button\n        role="button"\n        aria-label="Copy button. Click to copy component"\n        tabindex="-1"\n        class="btn btn-xxs btn-default component-settings-button component-settings-button-copy"\n        ref="copyComponent"\n      >\n        <i class="' + ((__t = ctx.iconClass('copy')) == null ? '' : __t) + '"></i>\n      </button>\n      <button\n        role="button"\n        aria-label="Paste below button. Click to paste component below the current component"\n        tabindex="-1"\n        class="btn btn-xxs btn-default component-settings-button component-settings-button-paste"\n        ref="pasteComponent"\n      >\n        <i class="' + ((__t = ctx.iconClass('save')) == null ? '' : __t) + '"></i>\n      </button>\n      <button\n        role="button"\n        aria-label="Edit json button. Click to edit json of the current component"\n        tabindex="-1"\n        class="btn btn-xxs btn-default component-settings-button component-settings-button-edit-json"\n        ref="editJson"\n      >\n        <i class="' + ((__t = ctx.iconClass('wrench')) == null ? '' : __t) + '"></i>\n      </button>\n      <button\n        role="button"\n        aria-label="Move button"\n        tabindex="-1"\n        class="btn btn-xxs btn-default component-settings-button component-settings-button-move"\n        ref="moveComponent"\n      >\n        <i class="' + ((__t = ctx.iconClass('move')) == null ? '' : __t) + '"></i>\n      </button>\n      <button\n        role="button"\n        aria-label="Edit button. Click to open component settings modal window"\n        tabindex="-1"\n        class="btn btn-xxs btn-secondary component-settings-button component-settings-button-edit"\n        ref="editComponent"\n      >\n        <i class="' + ((__t = ctx.iconClass('cog')) == null ? '' : __t) + '"></i>\n      </button>\n    </div>\n  ';
  }
  __p += '\n  ' + ((__t = ctx.html) == null ? '' : __t) + '\n</div>\n';
  return __p;
}

var builderComponent = {
  form: form$V
};

function form$U (ctx) {
  var __t,
    __p = '';
  __p += '<div class="builder-components drag-container formio-builder-' + ((__t = ctx.type) == null ? '' : __t) + '" ref="' + ((__t = ctx.key) == null ? '' : __t) + '-container">\n  ' + ((__t = ctx.html) == null ? '' : __t) + '\n</div>\n';
  return __p;
}

var builderComponents = {
  form: form$U
};

function form$T (ctx) {
  var __t,
    __p = '';
  __p += '<div class="flex flex-col w-full h-full">\n  <div>\n    <div class="grid grid-cols-12 gap-4">\n      <div class="col-span-6">\n        <div class="text-md px-3 py-3">\n          ' + ((__t = ctx.t(ctx.componentInfo.title, {
    _userInput: true
  })) == null ? '' : __t) + '\n          ' + ((__t = ctx.t('Component')) == null ? '' : __t) + '\n        </div>\n      </div>\n      ';
  if (ctx.helplinks) {
    __p += '\n      <div class="col-span-6 flex justify-end items-center pr-15">\n        <a class="reset-link inline-flex items-center text-secondary text-decoration-none hover:text-primary"\n           href="' + ((__t = ctx.t(ctx.helplinks + ctx.componentInfo.documentation)) == null ? '' : __t) + '" target="_blank">\n          <i class="' + ((__t = ctx.iconClass('new-window')) == null ? '' : __t) + ' mr-1"></i> ' + ((__t = ctx.t('Help')) == null ? '' : __t) + '\n        </a>\n      </div>\n      ';
  }
  __p += '\n    </div>\n  </div>\n  <div class="overflow-auto flex-1 p-3 pt-0" style="max-height: calc(90vh - 95px)">\n    <div class="grid grid-cols-12 gap-4">\n      <div class="';
  if (ctx.preview) {
    __p += 'col-span-12 sm:col-span-6';
  } else {
    __p += 'col-span-12';
  }
  __p += '">\n        <div ref="editForm">\n          ' + ((__t = ctx.editForm) == null ? '' : __t) + '\n        </div>\n      </div>\n      ';
  if (ctx.preview) {
    __p += '\n      <div class="col-span-12 sm:col-span-6">\n        <div class="card panel preview-panel">\n          <div class="card-header">\n            <div class="text-sm">' + ((__t = ctx.t('Preview')) == null ? '' : __t) + '</div>\n          </div>\n          <div class="card-body">\n            <div class="component-preview" ref="preview">\n              ' + ((__t = ctx.preview) == null ? '' : __t) + '\n            </div>\n          </div>\n        </div>\n        ';
    if (ctx.componentInfo.help) {
      __p += '\n        <div class="card card-body bg-light formio-settings-help">\n          ' + ((__t = ctx.t(ctx.componentInfo.help)) == null ? '' : __t) + '\n        </div>\n        ';
    }
    __p += '\n      </div>\n      ';
  }
  __p += '\n    </div>\n  </div>\n  <div class="bg-white p-2 flex justify-center">\n    <button class="btn btn-primary mx-2" ref="saveButton">\n      ' + ((__t = ctx.t('Save')) == null ? '' : __t) + '\n    </button>\n    <button class="btn btn-dark mx-2" ref="cancelButton">\n      ' + ((__t = ctx.t('Cancel')) == null ? '' : __t) + '\n    </button>\n    <button class="btn btn-danger mx-2" ref="removeButton">\n      <i class="' + ((__t = ctx.iconClass('remove')) == null ? '' : __t) + ' sm:mr-2"></i>\n      <span class="hidden sm:inline">' + ((__t = ctx.t('Remove')) == null ? '' : __t) + '</span>\n    </button>\n  </div>\n</div>\n\n\n';
  return __p;
}

var builderEditForm = {
  form: form$T
};

function form$S (ctx) {
  var __t,
    __p = '';
  __p += '<div\n  class="drag-and-drop-alert alert alert-info no-drag"\n  style="text-align:center;"\n  role="alert"\n  data-noattach="true"\n  data-position="' + ((__t = ctx.position) == null ? '' : __t) + '"\n>\n  ' + ((__t = ctx.t('Drag and Drop a form component')) == null ? '' : __t) + '\n</div>\n';
  return __p;
}

var builderPlaceholder = {
  form: form$S
};

function form$R (ctx) {
  var __t,
    __p = '';
  __p += '<div id="' + ((__t = ctx.groupId) == null ? '' : __t) + '" class="accordion builder-sidebar' + ((__t = ctx.scrollEnabled ? ' builder-sidebar_scroll' : '') == null ? '' : __t) + '" ref="sidebar">\n  <input class="form-control builder-sidebar_search" type="search" ref="sidebar-search" placeholder="Search field(s)" />\n  <div ref="sidebar-groups">\n    ';
  ctx.groups.forEach(function (group) {
    __p += '\n      ' + ((__t = group) == null ? '' : __t) + '\n    ';
  });
  __p += '\n  </div>\n</div>\n';
  return __p;
}

var builderSidebar = {
  form: form$R
};

function form$Q (ctx) {
  var __t,
    __p = '';
  __p += '<div class="card form-builder-panel" ref="group-panel-' + ((__t = ctx.groupKey) == null ? '' : __t) + '">\n  <div class="card-header form-builder-group-header" id="heading-' + ((__t = ctx.groupKey) == null ? '' : __t) + '">\n    <h5 class="mb-0 mt-0">\n      <button\n        class="btn btn-block builder-group-button"\n        type="button"\n        data-toggle="collapse"\n        data-target="#group-' + ((__t = ctx.groupKey) == null ? '' : __t) + '"\n        data-parent="#' + ((__t = ctx.groupId) == null ? '' : __t) + '"\n        aria-expanded="' + ((__t = ctx.group.default) == null ? '' : __t) + '"\n        aria-controls="group-' + ((__t = ctx.groupKey) == null ? '' : __t) + '"\n        ref="sidebar-anchor"\n      >\n        ' + ((__t = ctx.t(ctx.group.title)) == null ? '' : __t) + '\n      </button>\n    </h5>\n  </div>\n  <div\n    id="group-' + ((__t = ctx.groupKey) == null ? '' : __t) + '"\n    class="collapse ' + ((__t = ctx.group.default ? ' show' : '') == null ? '' : __t) + '"\n    data-parent="#' + ((__t = ctx.groupId) == null ? '' : __t) + '"\n    data-default="' + ((__t = ctx.group.default) == null ? '' : __t) + '"\n    aria-labelledby="heading-' + ((__t = ctx.groupKey) == null ? '' : __t) + '"\n    ref="sidebar-group"\n  >\n    <div id="group-container-' + ((__t = ctx.groupKey) == null ? '' : __t) + '" class="card-body no-drop p-2" ref="sidebar-container">\n      ';
  if (ctx.group.componentOrder.length || ctx.subgroups.length) {
    __p += '\n        ';
    !ctx.group.componentOrder || ctx.group.componentOrder.forEach(function (componentKey) {
      __p += '\n          <span\n            data-group="' + ((__t = ctx.groupKey) == null ? '' : __t) + '"\n            data-key="' + ((__t = ctx.group.components[componentKey].key) == null ? '' : __t) + '"\n            data-type="' + ((__t = ctx.group.components[componentKey].schema.type) == null ? '' : __t) + '"\n            class="btn btn-primary btn-sm btn-block formcomponent drag-copy"\n          >\n            ';
      if (ctx.group.components[componentKey].icon) {
        __p += '\n              <i class="' + ((__t = ctx.iconClass(ctx.group.components[componentKey].icon)) == null ? '' : __t) + '" style="margin-right: 5px;"></i>\n            ';
      }
      __p += '\n            ' + ((__t = ctx.t(ctx.group.components[componentKey].title, {
        _userInput: true
      })) == null ? '' : __t) + '\n          </span>\n        ';
    });
    __p += '\n        ' + ((__t = ctx.subgroups.join('')) == null ? '' : __t) + '\n      ';
  } else {
    __p += '\n        <div>' + ((__t = ctx.t('No Matches Found')) == null ? '' : __t) + '</div>\n      ';
  }
  __p += '\n    </div>\n  </div>\n</div>\n';
  return __p;
}

var builderSidebarGroup = {
  form: form$Q
};

function form$P (ctx) {
  var __t,
    __p = '';
  __p += '<div class="formio builder grid grid-cols-12 gap-4 formbuilder">\n  <div class="col-span-12 xs:col-span-4 sm:col-span-3 md:col-span-2 formcomponents">\n    ' + ((__t = ctx.sidebar) == null ? '' : __t) + '\n  </div>\n  <div class="col-span-12 xs:col-span-8 sm:col-span-9 md:col-span-10 formarea">\n    <ol class="breadcrumb bg-gray-200">\n      ';
  ctx.pages.forEach(function (page, pageIndex) {
    __p += '\n      <li class="text-gray-500">\n        <span title="' + ((__t = page.title) == null ? '' : __t) + '" class="mr-2 badge ';
    if (pageIndex === ctx.self.page) {
      __p += 'bg-primary';
    } else {
      __p += 'bg-light';
    }
    __p += ' wizard-page-label" ref="gotoPage">' + ((__t = page.title) == null ? '' : __t) + '</span>\n      </li>\n      ';
  });
  __p += '\n      <li class="text-gray-500 pl-2">\n        <span title="' + ((__t = ctx.t('Create Page')) == null ? '' : __t) + '" class="mr-2 badge bg-secondary wizard-page-label" ref="addPage">\n          <i class="' + ((__t = ctx.iconClass('plus')) == null ? '' : __t) + ' mr-1"></i> ' + ((__t = ctx.t('Page')) == null ? '' : __t) + '\n        </span>\n      </li>\n    </ol>\n    <div ref="form">\n      ' + ((__t = ctx.form) == null ? '' : __t) + '\n    </div>\n  </div>\n</div>\n';
  return __p;
}

var builderWizard = {
  form: form$P
};

function form$O (ctx) {
  var __t,
    __p = '';
  __p += '<' + ((__t = ctx.input.type) == null ? '' : __t) + '\n  ref="button"\n  ';
  for (var attr in ctx.input.attr) {
    __p += '\n  ' + ((__t = attr) == null ? '' : __t) + '="' + ((__t = ctx.input.attr[attr]) == null ? '' : __t) + '"\n  ';
  }
  __p += '\n  ';
  if (ctx.component.description) {
    __p += '\n    aria-describedby="d-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n  ';
  }
  __p += '\n>\n';
  if (ctx.component.leftIcon) {
    __p += '<span class="' + ((__t = ctx.component.leftIcon) == null ? '' : __t) + '"></span>&nbsp;';
  }
  __p += '\n';
  if (ctx.input.content) {
    __p += '<span>' + ((__t = ctx.input.content) == null ? '' : __t) + '</span> ';
  }
  __p += '\n';
  if (ctx.component.tooltip) {
    __p += '\n  <i ref="tooltip" class="' + ((__t = ctx.iconClass('question-sign')) == null ? '' : __t) + ' text-muted" data-tooltip="' + ((__t = ctx.component.tooltip) == null ? '' : __t) + '"></i>\n';
  }
  __p += '\n';
  if (ctx.component.rightIcon) {
    __p += '&nbsp;<span class="' + ((__t = ctx.component.rightIcon) == null ? '' : __t) + '"></span>';
  }
  __p += '\n</' + ((__t = ctx.input.type) == null ? '' : __t) + '>\n<div ref="buttonMessageContainer">\n  <span class="help-block" ref="buttonMessage"></span>\n</div>\n';
  return __p;
}

function html$b (ctx) {
  var __p = '';
  __p += '\n';
  return __p;
}

var button = {
  form: form$O,
  html: html$b
};

function form$N (ctx) {
  var __t,
    __p = '';
  __p += '<div class="form-check checkbox">\n  <label class="' + ((__t = ctx.input.labelClass) == null ? '' : __t) + ' form-check-label">\n    <' + ((__t = ctx.input.type) == null ? '' : __t) + '\n      ref="input"\n      ';
  for (var attr in ctx.input.attr) {
    __p += '\n      ' + ((__t = attr) == null ? '' : __t) + '="' + ((__t = ctx.input.attr[attr]) == null ? '' : __t) + '"\n      ';
  }
  __p += '\n      ';
  if (ctx.checked) {
    __p += 'checked=true';
  }
  __p += '\n      aria-required="' + ((__t = ctx.component.validate.required) == null ? '' : __t) + '"\n      ';
  if (ctx.component.description) {
    __p += '\n      aria-describedby="d-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n      ';
  }
  __p += '\n      >\n    ';
  if (!ctx.self.labelIsHidden()) {
    __p += '<span>' + ((__t = ctx.input.label) == null ? '' : __t) + '</span>';
  }
  __p += '\n    ';
  if (ctx.component.tooltip) {
    __p += '\n      <i ref="tooltip" tabindex="0" class="' + ((__t = ctx.iconClass('question-sign')) == null ? '' : __t) + ' text-muted" data-tooltip="' + ((__t = ctx.component.tooltip) == null ? '' : __t) + '"></i>\n    ';
  }
  __p += '\n    ' + ((__t = ctx.input.content) == null ? '' : __t) + '\n    </' + ((__t = ctx.input.type) == null ? '' : __t) + '>\n  </label>\n</div>\n';
  return __p;
}

function html$a (ctx) {
  var __t,
    __p = '';
  __p += '<label class="' + ((__t = ctx.input.labelClass) == null ? '' : __t) + '">\n    ' + ((__t = ctx.input.content) == null ? '' : __t) + '\n    ';
  if (!ctx.self.labelIsHidden()) {
    __p += '<span>' + ((__t = ctx.input.label) == null ? '' : __t) + '</span>';
  }
  __p += '\n</label>\n<div ref="value">';
  if (ctx.checked) {
    __p += 'True';
  } else {
    __p += 'False';
  }
  __p += '</div>\n';
  return __p;
}

var checkbox = {
  form: form$N,
  html: html$a
};

function form$M (ctx) {
  var __t,
    __p = '';
  ctx.component.columns.forEach(function (column, index) {
    __p += '\n<div class="\n    col-' + ((__t = column.size) == null ? '' : __t) + '-' + ((__t = column.currentWidth || column.width) == null ? '' : __t) + '\n    col-' + ((__t = column.size) == null ? '' : __t) + '-offset-' + ((__t = column.offset) == null ? '' : __t) + '\n    col-' + ((__t = column.size) == null ? '' : __t) + '-push-' + ((__t = column.push) == null ? '' : __t) + '\n    col-' + ((__t = column.size) == null ? '' : __t) + '-pull-' + ((__t = column.pull) == null ? '' : __t) + '\n  " ref="' + ((__t = ctx.columnKey) == null ? '' : __t) + '">\n  ' + ((__t = ctx.columnComponents[index]) == null ? '' : __t) + '\n</div>\n';
  });
  __p += '\n';
  return __p;
}

var columns = {
  form: form$M
};

function form$L (ctx) {
  var __t,
    __p = '';
  __p += '<div id="' + ((__t = ctx.id) == null ? '' : __t) + '" class="' + ((__t = ctx.classes) == null ? '' : __t) + '"';
  if (ctx.styles) {
    __p += ' styles="' + ((__t = ctx.styles) == null ? '' : __t) + '"';
  }
  __p += ' ref="component">\n  ';
  if (ctx.visible) {
    __p += '\n  ' + ((__t = ctx.children) == null ? '' : __t) + '\n  <div ref="messageContainer" class="formio-errors invalid-feedback"></div>\n  ';
  }
  __p += '\n</div>\n';
  return __p;
}

var component = {
  form: form$L
};

function form$K (ctx) {
  var __t,
    __p = '';
  __p += '<div class="formio-component-modal-wrapper formio-component-modal-wrapper-' + ((__t = ctx.component.type) == null ? '' : __t) + '" ref="componentModalWrapper">\n  <div ref="openModalWrapper"></div>\n  <div class="formio-dialog formio-dialog-theme-default component-rendering-hidden" ref="modalWrapper">\n    <div class="formio-dialog-overlay" ref="modalOverlay"></div>\n    <div class="formio-dialog-content" aria-labelledby="ml-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '" ';
  if (!ctx.self.isIE()) {
    __p += ' role="dialog" ';
  }
  __p += ' ref="modalContents">\n      <label class="sr-only" id="ml-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '">' + ((__t = ctx.t(ctx.component.label)) == null ? '' : __t) + '' + ((__t = ctx.self.isIE() ? ', dialog' : '') == null ? '' : __t) + '</label>\n      ';
  if (ctx.options.vpat) {
    __p += '\n      <button class="formio-dialog-close float-right" title="Close" aria-label="Close button. Click to get back to the form" ref="modalCloseButton"></button>\n      ';
  } else {
    __p += '\n      <button class="formio-dialog-close float-right btn btn-secondary btn-sm" aria-label="Close button. Click to get back to the form" ref="modalClose"></button>\n      ';
  }
  __p += '\n      <div ref="modalContents">\n        ';
  if (ctx.visible) {
    __p += '\n        ' + ((__t = ctx.children) == null ? '' : __t) + '\n        ';
  }
  __p += '\n        <div class="formio-dialog-buttons">\n          ';
  if (ctx.options.vpat) {
    __p += '\n          <button class="btn btn-secondary formio-dialog-button" aria-label="Cancel button. Click to cancel the changes and get back to the form." ref="modalClose">' + ((__t = ctx.t('Cancel')) == null ? '' : __t) + '</button>\n          ';
  }
  __p += '\n          <button class="btn btn-success formio-dialog-button" ref="modalSave" aria-label="Save button. Click to save the changes and get back to the form.">' + ((__t = ctx.t('Save')) == null ? '' : __t) + '</button>\n        </div>\n      </div>\n    </div>\n    <span class="sr-only" ref="modalLiveRegion" aria-live="assertive"></span>\n  </div>\n</div>\n';
  return __p;
}

var componentModal = {
  form: form$K
};

function form$J (ctx) {
  var __t,
    __p = '';
  __p += ((__t = ctx.children.join('')) == null ? '' : __t) + '\n';
  return __p;
}

var components = {
  form: form$J
};

function form$I (ctx) {
  var __t,
    __p = '';
  __p += '<div ref="' + ((__t = ctx.nestedKey) == null ? '' : __t) + '">\n  ' + ((__t = ctx.children) == null ? '' : __t) + '\n</div>\n';
  return __p;
}

var container = {
  form: form$I
};

var cssClasses = {
  "border-default": "",
  "formio-tab-panel-active": "active",
  "formio-tab-link-active": "active",
  "formio-tab-link-container-active": "active"
};

function form$H (ctx) {
  var __t,
    __p = '';
  __p += '<table class="table datagrid-table table-bordered\n    ' + ((__t = ctx.component.striped ? 'table-striped' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.hover ? 'table-hover' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.condensed ? 'table-sm' : '') == null ? '' : __t) + '\n    " ';
  if (ctx.component.layoutFixed) {
    __p += 'style="table-layout: fixed;"';
  }
  __p += '>\n  ';
  if (ctx.hasHeader) {
    __p += '\n  <thead>\n    <tr>\n      ';
    if (ctx.component.reorder) {
      __p += '<th></th>';
    }
    __p += '\n      ';
    ctx.columns.forEach(function (col) {
      __p += '\n        <th class="' + ((__t = col.validate && col.validate.required ? 'field-required' : '') == null ? '' : __t) + '">\n          ' + ((__t = col.hideLabel ? '' : ctx.t(col.label || col.title, {
        _userInput: true
      })) == null ? '' : __t) + '\n          ';
      if (col.tooltip) {
        __p += ' <i ref="tooltip" tabindex="0" data-title="' + ((__t = col.tooltip) == null ? '' : __t) + '" class="' + ((__t = ctx.iconClass('question-sign')) == null ? '' : __t) + ' text-muted" data-tooltip="' + ((__t = col.tooltip) == null ? '' : __t) + '"></i>';
      }
      __p += '\n        </th>\n      ';
    });
    __p += '\n      ';
    if (ctx.hasExtraColumn) {
      __p += '\n      <th>\n        <span class="sr-only">' + ((__t = ctx.t('Add/Remove')) == null ? '' : __t) + '</span>\n        ';
      if (!ctx.builder && ctx.hasAddButton && ctx.hasTopSubmit) {
        __p += '\n        <button class="btn btn-primary formio-button-add-row" ref="' + ((__t = ctx.datagridKey) == null ? '' : __t) + '-addRow" tabindex="' + ((__t = ctx.tabIndex) == null ? '' : __t) + '">\n          <i class="' + ((__t = ctx.iconClass('plus')) == null ? '' : __t) + '"></i>' + ((__t = ctx.t(ctx.component.addAnother || 'Add Another', {
          _userInput: true
        })) == null ? '' : __t) + '\n        </button>\n        ';
      }
      __p += '\n      </th>\n      ';
    }
    __p += '\n    </tr>\n  </thead>\n  ';
  }
  __p += '\n  <tbody ref="' + ((__t = ctx.datagridKey) == null ? '' : __t) + '-tbody" data-key="' + ((__t = ctx.datagridKey) == null ? '' : __t) + '">\n    ';
  ctx.rows.forEach(function (row, index) {
    __p += '\n    ';
    if (ctx.hasGroups && ctx.groups[index]) {
      __p += '\n    <tr ref="' + ((__t = ctx.datagridKey) == null ? '' : __t) + '-group-header" class="datagrid-group-header' + ((__t = ctx.hasToggle ? ' clickable' : '') == null ? '' : __t) + '">\n      <td\n        ref="' + ((__t = ctx.datagridKey) == null ? '' : __t) + '-group-label"\n        colspan="' + ((__t = ctx.numColumns) == null ? '' : __t) + '"\n        class="datagrid-group-label">' + ((__t = ctx.groups[index].label) == null ? '' : __t) + '</td>\n    </tr>\n    ';
    }
    __p += '\n    <tr ref="' + ((__t = ctx.datagridKey) == null ? '' : __t) + '-row">\n      ';
    if (ctx.component.reorder) {
      __p += '\n        <td class="align-middle">\n          <button type="button" class="formio-drag-button btn btn-sm btn-light ' + ((__t = ctx.iconClass('bars')) == null ? '' : __t) + '" data-key="' + ((__t = ctx.datagridKey) == null ? '' : __t) + '"></button>\n        </td>\n      ';
    }
    __p += '\n      ';
    ctx.columns.forEach(function (col) {
      __p += '\n        <td ref="' + ((__t = ctx.datagridKey) == null ? '' : __t) + '" ';
      if (col.key && col.overlay && col.overlay.width) {
        __p += ' style="width: ' + ((__t = col.overlay.width + 'px') == null ? '' : __t) + '"';
      }
      __p += ' >\n          ' + ((__t = row[col.key]) == null ? '' : __t) + '\n        </td>\n      ';
    });
    __p += '\n      ';
    if (ctx.hasExtraColumn) {
      __p += '\n        ';
      if (ctx.hasRemoveButtons) {
        __p += '\n        <td class="align-middle">\n          <button type="button" class="btn btn-light btn-sm formio-button-remove-row" ref="' + ((__t = ctx.datagridKey) == null ? '' : __t) + '-removeRow" tabindex="' + ((__t = ctx.tabIndex) == null ? '' : __t) + '" aria-label="' + ((__t = ctx.t('remove')) == null ? '' : __t) + '">\n            <i class="' + ((__t = ctx.iconClass('remove-circle')) == null ? '' : __t) + '"></i>\n          </button>\n        </td>\n        ';
      }
      __p += '\n        ';
      if (ctx.canAddColumn) {
        __p += '\n        <td ref="' + ((__t = ctx.key) == null ? '' : __t) + '-container">\n          ' + ((__t = ctx.placeholder) == null ? '' : __t) + '\n        </td>\n        ';
      }
      __p += '\n      ';
    }
    __p += '\n    </tr>\n    ';
  });
  __p += '\n  </tbody>\n  ';
  if (!ctx.builder && ctx.hasAddButton && ctx.hasBottomSubmit) {
    __p += '\n  <tfoot>\n    <tr>\n      <td colspan="' + ((__t = ctx.component.layoutFixed ? ctx.numColumns : ctx.numColumns + 1) == null ? '' : __t) + '">\n        <button class="btn btn-primary formio-button-add-row" ref="' + ((__t = ctx.datagridKey) == null ? '' : __t) + '-addRow" tabindex="' + ((__t = ctx.tabIndex) == null ? '' : __t) + '">\n          <i class="' + ((__t = ctx.iconClass('plus')) == null ? '' : __t) + ' mr-1"></i> ' + ((__t = ctx.t(ctx.component.addAnother || 'Add Another', {
      _userInput: true
    })) == null ? '' : __t) + '\n        </button>\n      </td>\n    </tr>\n  </tfoot>\n  ';
  }
  __p += '\n</table>\n';
  return __p;
}

function html$9 (ctx) {
  var __t,
    __p = '';
  __p += '<table class="table datagrid-table table-bordered\n    ' + ((__t = ctx.component.striped ? 'table-striped' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.hover ? 'table-hover' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.condensed ? 'table-sm' : '') == null ? '' : __t) + '\n    ">\n  ';
  if (ctx.hasHeader) {
    __p += '\n  <thead>\n    <tr>\n      ';
    ctx.columns.forEach(function (col) {
      __p += '\n        <th class="' + ((__t = col.validate && col.validate.required ? 'field-required' : '') == null ? '' : __t) + '">\n          ' + ((__t = col.hideLabel ? '' : ctx.t(col.label || col.title, {
        _userInput: true
      })) == null ? '' : __t) + '\n          ';
      if (col.tooltip) {
        __p += ' <i ref="tooltip" tabindex="0" data-title="' + ((__t = col.tooltip) == null ? '' : __t) + '" class="' + ((__t = ctx.iconClass('question-sign')) == null ? '' : __t) + ' text-muted" data-tooltip="' + ((__t = col.tooltip) == null ? '' : __t) + '"></i>';
      }
      __p += '\n        </th>\n      ';
    });
    __p += '\n    </tr>\n  </thead>\n  ';
  }
  __p += '\n  <tbody>\n    ';
  ctx.rows.forEach(function (row) {
    __p += '\n    <tr>\n      ';
    ctx.columns.forEach(function (col) {
      __p += '\n        <td ref="' + ((__t = ctx.datagridKey) == null ? '' : __t) + '">\n          ' + ((__t = row[col.key]) == null ? '' : __t) + '\n        </td>\n      ';
    });
    __p += '\n    </tr>\n    ';
  });
  __p += '\n  </tbody>\n</table>\n';
  return __p;
}

var datagrid = {
  form: form$H,
  html: html$9
};

function form$G (ctx) {
  var __t,
    __p = '';
  __p += '<div class="grid grid-cols-12 gap-4"\n  ';
  if (ctx.component.hideLabel) {
    __p += '\n  aria-label="' + ((__t = ctx.component.label) == null ? '' : __t) + '"\n  ';
  } else {
    __p += '\n  aria-labelledby="l-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n  ';
  }
  __p += '\n  ';
  if (ctx.component.description) {
    __p += '\n  aria-describedby="d-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n  ';
  }
  __p += '\n  >\n  ';
  if (ctx.dayFirst && ctx.showDay) {
    __p += '\n  <div class="col-span-3">\n    ';
    if (!ctx.component.hideInputLabels) {
      __p += '\n    <label for="' + ((__t = ctx.component.key) == null ? '' : __t) + '-day" class="';
      if (ctx.component.fields.day.required) {
        __p += 'field-required';
      }
      __p += '">' + ((__t = ctx.t('Day')) == null ? '' : __t) + '</label>\n    ';
    }
    __p += '\n    <div>' + ((__t = ctx.day) == null ? '' : __t) + '</div>\n  </div>\n  ';
  }
  __p += '\n  ';
  if (ctx.showMonth) {
    __p += '\n  <div class="col-span-4">\n    ';
    if (!ctx.component.hideInputLabels) {
      __p += '\n    <label for="' + ((__t = ctx.component.key) == null ? '' : __t) + '-month" class="';
      if (ctx.component.fields.month.required) {
        __p += 'field-required';
      }
      __p += '">' + ((__t = ctx.t('Month')) == null ? '' : __t) + '</label>\n    ';
    }
    __p += '\n    <div>' + ((__t = ctx.month) == null ? '' : __t) + '</div>\n  </div>\n  ';
  }
  __p += '\n  ';
  if (!ctx.dayFirst && ctx.showDay) {
    __p += '\n  <div class="col-span-3">\n    ';
    if (!ctx.component.hideInputLabels) {
      __p += '\n    <label for="' + ((__t = ctx.component.key) == null ? '' : __t) + '-day" class="';
      if (ctx.component.fields.day.required) {
        __p += 'field-required';
      }
      __p += '">' + ((__t = ctx.t('Day')) == null ? '' : __t) + '</label>\n    ';
    }
    __p += '\n    <div>' + ((__t = ctx.day) == null ? '' : __t) + '</div>\n  </div>\n  ';
  }
  __p += '\n  ';
  if (ctx.showYear) {
    __p += '\n  <div class="col-span-5">\n    ';
    if (!ctx.component.hideInputLabels) {
      __p += '\n    <label for="' + ((__t = ctx.component.key) == null ? '' : __t) + '-year" class="';
      if (ctx.component.fields.year.required) {
        __p += 'field-required';
      }
      __p += '">' + ((__t = ctx.t('Year')) == null ? '' : __t) + '</label>\n    ';
    }
    __p += '\n    <div>' + ((__t = ctx.year) == null ? '' : __t) + '</div>\n  </div>\n  ';
  }
  __p += '\n</div>\n<input name="ctx.data[day]" type="hidden" class="form-control" lang="en" value="" ref="input">\n';
  return __p;
}

var day = {
  form: form$G
};

function form$F (ctx) {
  var __p = '';
  __p += '<div class="formio-dialog formio-dialog-theme-default component-settings">\n  <div class="formio-dialog-overlay" ref="dialogOverlay"></div>\n  <div class="formio-dialog-content" ref="dialogContents" role="dialog">\n    <div ref="dialogContents"></div>\n    <button class="formio-dialog-close float-right btn btn-secondary btn-sm" aria-label="Close modal window." ref="dialogClose"></button>\n  </div>\n</div>\n';
  return __p;
}

var dialog = {
  form: form$F
};

function form$E (ctx) {
  var __t,
    __p = '';
  __p += '<ul class="editgrid-listgroup list-group\n    ' + ((__t = ctx.component.striped ? 'table-striped' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.bordered ? 'table-bordered' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.hover ? 'table-hover' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.condensed ? 'table-sm' : '') == null ? '' : __t) + '\n    ">\n  ';
  if (ctx.header) {
    __p += '\n  <li class="list-group-item list-group-header">\n    ' + ((__t = ctx.header) == null ? '' : __t) + '\n  </li>\n  ';
  }
  __p += '\n  ';
  ctx.rows.forEach(function (row, rowIndex) {
    __p += '\n  <li class="list-group-item" ref="' + ((__t = ctx.ref.row) == null ? '' : __t) + '">\n    ' + ((__t = row) == null ? '' : __t) + '\n    ';
    if (ctx.openRows[rowIndex] && !ctx.readOnly) {
      __p += '\n    <div class="editgrid-actions">\n      <button class="btn btn-primary" ref="' + ((__t = ctx.ref.saveRow) == null ? '' : __t) + '">' + ((__t = ctx.t(ctx.component.saveRow || 'Save', {
        _userInput: true
      })) == null ? '' : __t) + '</button>\n      ';
      if (ctx.component.removeRow) {
        __p += '\n      <button class="btn btn-danger" ref="' + ((__t = ctx.ref.cancelRow) == null ? '' : __t) + '">' + ((__t = ctx.t(ctx.component.removeRow || 'Cancel', {
          _userInput: true
        })) == null ? '' : __t) + '</button>\n      ';
      }
      __p += '\n    </div>\n    ';
    }
    __p += '\n    <div class="has-error">\n      <div class="editgrid-row-error help-block">\n        ' + ((__t = ctx.errors[rowIndex]) == null ? '' : __t) + '\n      </div>\n    </div>\n  </li>\n  ';
  });
  __p += '\n  ';
  if (ctx.footer) {
    __p += '\n  <li class="list-group-item list-group-footer">\n    ' + ((__t = ctx.footer) == null ? '' : __t) + '\n  </li>\n  ';
  }
  __p += '\n</ul>\n';
  if (!ctx.readOnly && ctx.hasAddButton) {
    __p += '\n<button class="btn btn-primary" ref="' + ((__t = ctx.ref.addRow) == null ? '' : __t) + '">\n  <i class="' + ((__t = ctx.iconClass('plus')) == null ? '' : __t) + '"></i> ' + ((__t = ctx.t(ctx.component.addAnother || 'Add Another', {
      _userInput: true
    })) == null ? '' : __t) + '\n</button>\n';
  }
  __p += '\n';
  return __p;
}

function html$8 (ctx) {
  var __t,
    __p = '';
  __p += '<ul class="editgrid-listgroup list-group\n    ' + ((__t = ctx.component.striped ? 'table-striped' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.bordered ? 'table-bordered' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.hover ? 'table-hover' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.condensed ? 'table-sm' : '') == null ? '' : __t) + '\n    ">\n  ';
  if (ctx.header) {
    __p += '\n  <li class="list-group-item list-group-header">\n    ' + ((__t = ctx.header) == null ? '' : __t) + '\n  </li>\n  ';
  }
  __p += '\n  ';
  ctx.rows.forEach(function (row, rowIndex) {
    __p += '\n  <li class="list-group-item" ref="' + ((__t = ctx.ref.row) == null ? '' : __t) + '">\n    ' + ((__t = row) == null ? '' : __t) + '\n    ';
    if (ctx.openRows[rowIndex] && !ctx.readOnly) {
      __p += '\n    <div class="editgrid-actions">\n      <button class="btn btn-primary" ref="' + ((__t = ctx.ref.saveRow) == null ? '' : __t) + '">' + ((__t = ctx.t(ctx.component.saveRow || 'Save', {
        _userInput: true
      })) == null ? '' : __t) + '</button>\n      ';
      if (ctx.component.removeRow) {
        __p += '\n      <button class="btn btn-danger" ref="' + ((__t = ctx.ref.cancelRow) == null ? '' : __t) + '">' + ((__t = ctx.t(ctx.component.removeRow || 'Cancel', {
          _userInput: true
        })) == null ? '' : __t) + '</button>\n      ';
      }
      __p += '\n    </div>\n    ';
    }
    __p += '\n    <div class="has-error">\n      <div class="editgrid-row-error help-block">\n        ' + ((__t = ctx.errors[rowIndex]) == null ? '' : __t) + '\n      </div>\n    </div>\n  </li>\n  ';
  });
  __p += '\n  ';
  if (ctx.footer) {
    __p += '\n  <li class="list-group-item list-group-footer">\n    ' + ((__t = ctx.footer) == null ? '' : __t) + '\n  </li>\n  ';
  }
  __p += '\n</ul>\n';
  return __p;
}

var editgrid = {
  form: form$E,
  html: html$8
};

function form$D (ctx) {
  var __t,
    __p = '';
  __p += '<div class="editgrid-table-container">\n  <div class="table-responsive">\n    <table class="table\n      ' + ((__t = ctx.component.striped ? 'table-striped' : '') == null ? '' : __t) + '\n      ' + ((__t = ctx.component.bordered ? 'table-bordered' : '') == null ? '' : __t) + '\n      ' + ((__t = ctx.component.hover ? 'table-hover' : '') == null ? '' : __t) + '\n      ' + ((__t = ctx.component.condensed ? 'table-sm' : '') == null ? '' : __t) + '\n    ">\n      ';
  if (ctx.header) {
    __p += '\n      <thead class="editgrid-table-head">\n        ' + ((__t = ctx.header) == null ? '' : __t) + '\n      </thead>\n      ';
  }
  __p += '\n      <tbody class="editgrid-table-body">\n        ';
  ctx.rows.forEach(function (row, rowIndex) {
    __p += '\n        <tr ref="' + ((__t = ctx.ref.row) == null ? '' : __t) + '">\n          ' + ((__t = row) == null ? '' : __t) + '\n          ';
    if (ctx.openRows[rowIndex] && !ctx.readOnly) {
      __p += '\n            <td class="editgrid-table-column">\n              <div class="editgrid-actions">\n                <button class="btn btn-primary" ref="' + ((__t = ctx.ref.saveRow) == null ? '' : __t) + '">' + ((__t = ctx.t(ctx.component.saveRow || 'Save', {
        _userInput: true
      })) == null ? '' : __t) + '</button>\n                ';
      if (ctx.component.removeRow) {
        __p += '\n                <button class="btn btn-danger" ref="' + ((__t = ctx.ref.cancelRow) == null ? '' : __t) + '">' + ((__t = ctx.t(ctx.component.removeRow || 'Cancel', {
          _userInput: true
        })) == null ? '' : __t) + '</button>\n                ';
      }
      __p += '\n              </div>\n            </td>\n          ';
    }
    __p += '\n          ';
    if (ctx.errors[rowIndex]) {
      __p += '\n          <td class="editgrid-table-column">\n            <div class="has-error">\n              <div class="editgrid-row-error help-block">\n                ' + ((__t = ctx.errors[rowIndex]) == null ? '' : __t) + '\n              </div>\n            </div>\n          </td>\n          ';
    }
    __p += '\n        </tr>\n        ';
  });
  __p += '\n      </tbody>\n      ';
  if (ctx.footer) {
    __p += '\n      <tfoot>\n        <tr>\n          ' + ((__t = ctx.footer) == null ? '' : __t) + '\n        </tr>\n      <tfoot>\n      ';
  }
  __p += '\n    </table>\n  </div>\n</div>\n';
  if (!ctx.readOnly && ctx.hasAddButton) {
    __p += '\n<button class="btn btn-primary" ref="' + ((__t = ctx.ref.addRow) == null ? '' : __t) + '">\n  <i class="' + ((__t = ctx.iconClass('plus')) == null ? '' : __t) + '"></i>\n  ' + ((__t = ctx.t(ctx.component.addAnother || 'Add Another', {
      _userInput: true
    })) == null ? '' : __t) + '\n</button>\n';
  }
  __p += '\n';
  return __p;
}

function html$7 (ctx) {
  var __t,
    __p = '';
  __p += '<div class="editgrid-table-container">\n  <div class="table-responsive">\n    <table class="table\n      ' + ((__t = ctx.component.striped ? 'table-striped' : '') == null ? '' : __t) + '\n      ' + ((__t = ctx.component.bordered ? 'table-bordered' : '') == null ? '' : __t) + '\n      ' + ((__t = ctx.component.hover ? 'table-hover' : '') == null ? '' : __t) + '\n      ' + ((__t = ctx.component.condensed ? 'table-sm' : '') == null ? '' : __t) + '\n    ">\n      ';
  if (ctx.header) {
    __p += '\n      <thead class="editgrid-table-head">\n        ' + ((__t = ctx.header) == null ? '' : __t) + '\n      </thead>\n      ';
  }
  __p += '\n      <tbody class="editgrid-table-body">\n        ';
  ctx.rows.forEach(function (row, rowIndex) {
    __p += '\n        <tr ref="' + ((__t = ctx.ref.row) == null ? '' : __t) + '">\n          ' + ((__t = row) == null ? '' : __t) + '\n          ';
    if (ctx.openRows[rowIndex] && !ctx.readOnly) {
      __p += '\n          <td class="editgrid-table-column">\n            <div class="editgrid-actions">\n              <button class="btn btn-primary" ref="' + ((__t = ctx.ref.saveRow) == null ? '' : __t) + '">' + ((__t = ctx.t(ctx.component.saveRow || 'Save', {
        _userInput: true
      })) == null ? '' : __t) + '</button>\n              ';
      if (ctx.component.removeRow) {
        __p += '\n              <button class="btn btn-danger" ref="' + ((__t = ctx.ref.cancelRow) == null ? '' : __t) + '">' + ((__t = ctx.t(ctx.component.removeRow || 'Cancel', {
          _userInput: true
        })) == null ? '' : __t) + '</button>\n              ';
      }
      __p += '\n            </div>\n          </td>\n          ';
    }
    __p += '\n          ';
    if (ctx.errors[rowIndex]) {
      __p += '\n          <td class="editgrid-table-column">\n            <div class="has-error">\n              <div class="editgrid-row-error help-block">\n                ' + ((__t = ctx.errors[rowIndex]) == null ? '' : __t) + '\n              </div>\n            </div>\n          </td>\n          ';
    }
    __p += '\n        </tr>\n        ';
  });
  __p += '\n      </tbody>\n      ';
  if (ctx.footer) {
    __p += '\n      <tfoot>\n        <tr>\n          ' + ((__t = ctx.footer) == null ? '' : __t) + '\n         </tr>\n      <tfoot>\n      ';
  }
  __p += '\n    </table>\n  </div>\n</div>\n';
  return __p;
}

var editgridTable = {
  form: form$D,
  html: html$7
};

function form$C (ctx) {
  var __t,
    __p = '';
  __p += '<p>' + ((__t = ctx.t('error')) == null ? '' : __t) + '\n  ';
  if (ctx.options.vpat) {
    __p += '\n  <span ref="errorTooltip" class="' + ((__t = ctx.iconClass('question-sign')) == null ? '' : __t) + '" tabindex="0"></span>\n  ';
  }
  __p += '\n</p>\n<ul>\n  ';
  ctx.errors.forEach(function (err) {
    __p += '\n  <li>\n    <span\n      data-component-key = "' + ((__t = err.keyOrPath) == null ? '' : __t) + '"\n      ref = "errorRef"\n      tabIndex = "0"\n      role="link"\n    >\n      ' + ((__t = err.message) == null ? '' : __t) + '\n    </span>\n  </li>\n  ';
  });
  __p += '\n</ul>\n';
  return __p;
}

var errorsList = {
  form: form$C
};

function align (ctx) {
  var __t,
    __p = '';
  __p += '<div class="field-wrapper\n  ' + ((__t = ctx.isRightPosition ? 'field-wrapper--reverse' : '') == null ? '' : __t) + '">\n  ';
  if (!ctx.label.hidden) {
    __p += '\n    <div class="field-label\n      ' + ((__t = ctx.isRightAlign ? 'field-label--right' : '') == null ? '' : __t) + '"\n      style="' + ((__t = ctx.labelStyles) == null ? '' : __t) + '">\n    ' + ((__t = ctx.labelMarkup) == null ? '' : __t) + '\n    </div>\n  ';
  }
  __p += '\n\n  ';
  if (ctx.label.hidden && ctx.label.className && ctx.component.validate.required) {
    __p += '\n    <div class="field-label\n      ' + ((__t = ctx.isRightAlign ? 'field-label--right' : '') == null ? '' : __t) + '"\n      style="' + ((__t = ctx.labelStyles) == null ? '' : __t) + '">\n      <label class="' + ((__t = ctx.label.className) == null ? '' : __t) + '"></label>\n    </div>\n  ';
  }
  __p += '\n\n  <div class="field-content" style="' + ((__t = ctx.contentStyles) == null ? '' : __t) + '">\n    ' + ((__t = ctx.element) == null ? '' : __t) + '\n  </div>\n</div>\n\n';
  if (ctx.component.description) {
    __p += '\n  <div class="form-text text-muted">' + ((__t = ctx.t(ctx.component.description, {
      _userInput: true
    })) == null ? '' : __t) + '</div>\n';
  }
  __p += '\n';
  return __p;
}

function form$B (ctx) {
  var __t,
    __p = '';
  if (!ctx.label.hidden && ctx.label.labelPosition !== 'bottom') {
    __p += '\n  ' + ((__t = ctx.labelMarkup) == null ? '' : __t) + '\n';
  }
  __p += '\n\n';
  if (ctx.label.hidden && ctx.label.className && ctx.component.validate.required) {
    __p += '\n  <label class="' + ((__t = ctx.label.className) == null ? '' : __t) + '"></label>\n';
  }
  __p += '\n\n' + ((__t = ctx.element) == null ? '' : __t) + '\n\n';
  if (!ctx.label.hidden && ctx.label.labelPosition === 'bottom') {
    __p += '\n  ' + ((__t = ctx.labelMarkup) == null ? '' : __t) + '\n';
  }
  __p += '\n';
  if (ctx.component.description) {
    __p += '\n  <div id="d-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '" class="form-text text-muted">' + ((__t = ctx.t(ctx.component.description, {
      _userInput: true
    })) == null ? '' : __t) + '</div>\n';
  }
  __p += '\n';
  return __p;
}

var field = {
  form: form$B,
  align
};

function form$A (ctx) {
  var __t,
    __p = '';
  __p += '<fieldset>\n  ';
  if (ctx.component.legend) {
    __p += '\n  <legend ref="header" class="' + ((__t = ctx.component.collapsible ? 'formio-clickable' : '') == null ? '' : __t) + '">\n    ' + ((__t = ctx.t(ctx.component.legend, {
      _userInput: true
    })) == null ? '' : __t) + '\n    ';
    if (ctx.component.tooltip) {
      __p += '\n      <i ref="tooltip" tabindex="0" class="' + ((__t = ctx.iconClass('question-sign')) == null ? '' : __t) + ' text-muted" data-tooltip="' + ((__t = ctx.component.tooltip) == null ? '' : __t) + '"></i>\n    ';
    }
    __p += '\n  </legend>\n  ';
  }
  __p += '\n  ';
  if (!ctx.collapsed) {
    __p += '\n  <div class="fieldset-body" ref="' + ((__t = ctx.nestedKey) == null ? '' : __t) + '">\n    ' + ((__t = ctx.children) == null ? '' : __t) + '\n  </div>\n  ';
  }
  __p += '\n</fieldset>\n\n';
  return __p;
}

var fieldset = {
  form: form$A
};

function form$z (ctx) {
  var __t,
    __p = '';
  if (ctx.options.vpat) {
    __p += '\n  <span tabindex="-1" class="sr-only" id="invisible-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"></span>\n';
  }
  __p += '\n';
  if (!ctx.self.imageUpload) {
    __p += '\n  ';
    if (ctx.options.vpat) {
      __p += '\n    <div>' + ((__t = !ctx.component.filePattern || ctx.component.filePattern === '*' ? 'Any file types are allowed' : ctx.t('Allowed file types: ') + ctx.component.filePattern) == null ? '' : __t) + '</div>\n  ';
    }
    __p += '\n  <ul class="list-group list-group-striped">\n    <li class="list-group-item list-group-header hidden-xs hidden-sm">\n      <div class="grid grid-cols-12 gap-4">\n        ';
    if (!ctx.disabled) {
      __p += '\n          <div class="md:col-span-1"></div>\n        ';
    }
    __p += '\n        <div class="md:col-span-';
    if (ctx.self.hasTypes) {
      __p += '7';
    } else {
      __p += '9';
    }
    __p += '"><strong>' + ((__t = ctx.t('File Name')) == null ? '' : __t) + '</strong></div>\n        <div class="md:col-span-2"><strong>' + ((__t = ctx.t('Size')) == null ? '' : __t) + '</strong></div>\n        ';
    if (ctx.self.hasTypes) {
      __p += '\n          <div class="md:col-span-2"><strong>' + ((__t = ctx.t('Type')) == null ? '' : __t) + '</strong></div>\n        ';
    }
    __p += '\n      </div>\n    </li>\n    ';
    ctx.files.forEach(function (file) {
      __p += '\n      <li class="list-group-item">\n        <div class="grid grid-cols-12 gap-4">\n          ';
      if (!ctx.disabled) {
        __p += '\n            <div class="md:col-span-1"><i tabindex="0" class="' + ((__t = ctx.iconClass('remove')) == null ? '' : __t) + '" ref="removeLink"></i></div>\n          ';
      }
      __p += '\n          <div class="md:col-span-';
      if (ctx.self.hasTypes) {
        __p += '7';
      } else {
        __p += '9';
      }
      __p += '">\n            ';
      if (ctx.component.uploadOnly) {
        __p += '\n              ' + ((__t = file.originalName || file.name) == null ? '' : __t) + '\n            ';
      } else {
        __p += '\n              <a href="' + ((__t = file.url || '#') == null ? '' : __t) + '" target="_blank" ref="fileLink">\n                <span class="sr-only">' + ((__t = ctx.t('Press to open ')) == null ? '' : __t) + '</span>' + ((__t = file.originalName || file.name) == null ? '' : __t) + '\n              </a>\n            ';
      }
      __p += '\n          </div>\n          <div class="md:col-span-2">' + ((__t = ctx.fileSize(file.size)) == null ? '' : __t) + '</div>\n          ';
      if (ctx.self.hasTypes && !ctx.disabled) {
        __p += '\n            <div class="md:col-span-2">\n              <select class="file-type" ref="fileType">\n                ';
        ctx.component.fileTypes.map(function (type) {
          __p += '\n                  <option class="test" value="' + ((__t = type.value) == null ? '' : __t) + '" ';
          if (type.label === file.fileType) {
            __p += 'selected="selected"';
          }
          __p += '>' + ((__t = ctx.t(type.label)) == null ? '' : __t) + '</option>\n                ';
        });
        __p += '\n              </select>\n            </div>\n          ';
      }
      __p += '\n          ';
      if (ctx.self.hasTypes && ctx.disabled) {
        __p += '\n          <div class="md:col-span-2">' + ((__t = file.fileType) == null ? '' : __t) + '</div>\n          ';
      }
      __p += '\n        </div>\n      </li>\n    ';
    });
    __p += '\n  </ul>\n';
  } else {
    __p += '\n  <div>\n    ';
    ctx.files.forEach(function (file) {
      __p += '\n      <div>\n        <span>\n          <img ref="fileImage" src="" alt="' + ((__t = file.originalName || file.name) == null ? '' : __t) + '" style="width:' + ((__t = ctx.component.imageSize) == null ? '' : __t) + 'px">\n          ';
      if (!ctx.disabled) {
        __p += '\n            <i tabindex="0" class="' + ((__t = ctx.iconClass('remove')) == null ? '' : __t) + '" ref="removeLink"></i>\n          ';
      }
      __p += '\n        </span>\n      </div>\n    ';
    });
    __p += '\n  </div>\n';
  }
  __p += '\n';
  if (!ctx.disabled && (ctx.component.multiple || !ctx.files.length)) {
    __p += '\n  ';
    if (ctx.self.useWebViewCamera) {
      __p += '\n    <div class="fileSelector">\n      <button class="btn btn-primary" ref="galleryButton"><i class="fa fa-book"></i> ' + ((__t = ctx.t('Gallery')) == null ? '' : __t) + '</button>\n      <button class="btn btn-primary" ref="cameraButton"><i class="fa fa-camera"></i> ' + ((__t = ctx.t('Camera')) == null ? '' : __t) + '</button>\n    </div>\n  ';
    } else if (!ctx.self.cameraMode) {
      __p += '\n    <div class="fileSelector" ref="fileDrop" ' + ((__t = ctx.fileDropHidden ? 'hidden' : '') == null ? '' : __t) + '>\n      <i class="' + ((__t = ctx.iconClass('cloud-upload')) == null ? '' : __t) + '"></i> ' + ((__t = ctx.t('Drop files to attach,')) == null ? '' : __t) + '\n        ';
      if (ctx.self.imageUpload && ctx.component.webcam) {
        __p += '\n          <a href="#" ref="toggleCameraMode"><i class="' + ((__t = ctx.iconClass('camera')) == null ? '' : __t) + '"></i> ' + ((__t = ctx.t('use camera')) == null ? '' : __t) + '</a>\n        ';
      }
      __p += '\n        ' + ((__t = ctx.t('or')) == null ? '' : __t) + '\n        <a href="#" ref="fileBrowse" class="browse">\n          ' + ((__t = ctx.t('browse')) == null ? '' : __t) + '\n          <span class="sr-only">\n            ' + ((__t = ctx.t('Browse to attach file for ' + ctx.component.label + '. ' + (ctx.component.description ? ctx.component.description + '. ' : '') + (!ctx.component.filePattern || ctx.component.filePattern === '*' ? 'Any file types are allowed' : ctx.t('Allowed file types: ') + ctx.component.filePattern))) == null ? '' : __t) + '\n          </span>\n        </a>\n      <div ref="fileProcessingLoader" class="loader-wrapper">\n        <div class="loader text-center"></div>\n      </div>\n    </div>\n  ';
    } else {
      __p += '\n    <div class="video-container">\n      <video class="video" autoplay="true" ref="videoPlayer" tabindex="-1"></video>\n    </div>\n    <button class="btn btn-primary" ref="takePictureButton"><i class="fa fa-camera"></i> ' + ((__t = ctx.t('Take Picture')) == null ? '' : __t) + '</button>\n    <button class="btn btn-primary" ref="toggleCameraMode">' + ((__t = ctx.t('Switch to file upload')) == null ? '' : __t) + '</button>\n  ';
    }
    __p += '\n';
  }
  __p += '\n';
  ctx.statuses.forEach(function (status) {
    __p += '\n  <div class="file ' + ((__t = ctx.statuses.status === 'error' ? ' has-error' : '') == null ? '' : __t) + '">\n    <div class="grid grid-cols-12 gap-4">\n      <div class="fileName col-form-label sm:col-span-10">' + ((__t = status.originalName) == null ? '' : __t) + '\n        <i class="' + ((__t = ctx.iconClass('remove')) == null ? '' : __t) + '" ref="fileStatusRemove">\n          <span class="sr-only">' + ((__t = ctx.t('Remove button. Press to remove ' + status.originalName || status.name + '.')) == null ? '' : __t) + '</span>\n          <span class="sr-only">' + ((__t = status.message ? status.message.replace(';', '.') : '') == null ? '' : __t) + '</span>\n        </i>\n      </div>\n      <div class="fileSize col-form-label sm:col-span-2 text-right">' + ((__t = ctx.fileSize(status.size)) == null ? '' : __t) + '</div>\n    </div>\n    <div class="grid grid-cols-12 gap-4">\n      <div class="sm:col-span-12">\n        ';
    if (status.status === 'progress') {
      __p += '\n          <div class="progress">\n            <div class="progress-bar" role="progressbar" aria-valuenow="' + ((__t = status.progress) == null ? '' : __t) + '" aria-valuemin="0" aria-valuemax="100" style="width: ' + ((__t = status.progress) == null ? '' : __t) + '%">\n              <span class="sr-only">' + ((__t = status.progress) == null ? '' : __t) + '% ' + ((__t = ctx.t('Complete')) == null ? '' : __t) + '</span>\n            </div>\n          </div>\n        ';
    } else if (status.status === 'error') {
      __p += '\n          <div class="alert alert-danger bg-' + ((__t = status.status) == null ? '' : __t) + '">' + ((__t = ctx.t(status.message)) == null ? '' : __t) + '</div>\n        ';
    } else {
      __p += '\n          <div class="bg-' + ((__t = status.status) == null ? '' : __t) + '">' + ((__t = ctx.t(status.message)) == null ? '' : __t) + '</div>\n        ';
    }
    __p += '\n      </div>\n    </div>\n  </div>\n';
  });
  __p += '\n';
  if (!ctx.component.storage || ctx.support.hasWarning) {
    __p += '\n  <div class="alert alert-warning">\n    ';
    if (!ctx.component.storage) {
      __p += '\n      <p>' + ((__t = ctx.t('No storage has been set for this field. File uploads are disabled until storage is set up.')) == null ? '' : __t) + '</p>\n    ';
    }
    __p += '\n    ';
    if (!ctx.support.filereader) {
      __p += '\n      <p>' + ((__t = ctx.t('File API & FileReader API not supported.')) == null ? '' : __t) + '</p>\n    ';
    }
    __p += '\n    ';
    if (!ctx.support.formdata) {
      __p += '\n      <p>' + ((__t = ctx.t("XHR2's FormData is not supported.")) == null ? '' : __t) + '</p>\n    ';
    }
    __p += '\n    ';
    if (!ctx.support.progress) {
      __p += '\n      <p>' + ((__t = ctx.t("XHR2's upload progress isn't supported.")) == null ? '' : __t) + '</p>\n    ';
    }
    __p += '\n  </div>\n';
  }
  __p += '\n';
  return __p;
}

var file = {
  form: form$z
};

function form$y (ctx) {
  var __t,
    __p = '';
  __p += '<' + ((__t = ctx.tag) == null ? '' : __t) + ' class="' + ((__t = ctx.component.className) == null ? '' : __t) + '" ref="html"\n  ';
  ctx.attrs.forEach(function (attr) {
    __p += '\n    ' + ((__t = attr.attr) == null ? '' : __t) + '="' + ((__t = attr.value) == null ? '' : __t) + '"\n  ';
  });
  __p += '\n>' + ((__t = ctx.t(ctx.content)) == null ? '' : __t);
  if (!ctx.singleTags || ctx.singleTags.indexOf(ctx.tag) === -1) {
    __p += '</' + ((__t = ctx.tag) == null ? '' : __t) + '>';
  }
  __p += '\n';
  return __p;
}

var html$6 = {
  form: form$y
};

function form$x (ctx) {
  var __t,
    __p = '';
  __p += '<i ref="' + ((__t = ctx.ref) == null ? '' : __t) + '" class="' + ((__t = ctx.className) == null ? '' : __t) + '" style="' + ((__t = ctx.styles) == null ? '' : __t) + '">' + ((__t = ctx.content) == null ? '' : __t) + '</i>\n';
  return __p;
}

var icon = {
  form: form$x
};

const ICONS = {
  remove: "bxs-trash",
  "question-sign": "bx-question-mark inline-block border-1 bg-gray-400 border-solid border-gray-400 text-white text-xxs rounded-full mx-2 mt-px",
  "new-window": "bx-windows",
  "minus-square-o": "bxs-minus-square",
  cog: "bx-cog",
  move: "bx-move",
  wrench: "bx-wrench",
  save: "bx-save",
  copy: "bx-copy",
  calendar: "bx-calendar",
  file: "bx-file",
  wpforms: "bxs-spreadsheet",
  "files-o": "bx-copy-alt",
  refresh: "bx-refresh",
  indent: "bx-right-indent",
  tasks: "bx-list-ul",
  th: "bx-table",
  "th-list": "bxs-spreadsheet",
  "folder-open": "bx-folder-open",
  "folder-o": "bx-folder-open",
  "user-secret": "bxs-user-badge",
  table: "bx-table",
  pencil: "bx-pencil",
  code: "bx-code",
  terminal: "bx-terminal",
  home: "bx-home",
  html5: "bxl-html5",
  list: "bx-list-ul",
  usd: "bx-dollar",
  hashtag: "bx-hash",
  tags: "bx-purchase-tag",
  at: "bx-at",
  font: "bx-font",
  asterisk: "bx-show",
  plus: "bx-plus",
  "plus-square": "bx-plus-circle",
  "plus-square-o": "bxs-plus-square",
  "dot-circle-o": "bx-radio-circle-marked",
  "phone-square": "bx-phone",
  "clock-o": "bx-time-five",
  link: "bx-link",
  columns: "bx-columns",
  "th-large": "bx-category",
  "list-alt": "bx-credit-card-front",
  "square-o": "bx-caret-down-square",
  cubes: "bxs-cube",
  stop: "bx-stop",
  "check-square": "bx-checkbox-checked",
  "remove-circle": "bx-x",
  bars: "bx-menu"
};
var iconClass = ((iconset, name, spinning) => {
  if (iconset === "bx") {
    if (ICONS[name]) {
      name = ICONS[name];
    } else {
      name = `${iconset}-${name}`;
    }
  }
  if (spinning) {
    if (name === "bx-radio-circle") {
      return `${iconset} ${name} bx-burst`;
    }
    return `${iconset} ${name} bx-spin`;
  }
  return `${iconset} ${name}`;
});

function form$w (ctx) {
  var __t,
    __p = '';
  if (ctx.prefix || ctx.suffix) {
    __p += '\n<div class="input-group">\n  ';
  }
  __p += '\n  ';
  if (ctx.prefix) {
    __p += '\n    <div class="input-group-prepend" ref="prefix">\n    <span class="input-group-text">\n      ';
    if (ctx.prefix instanceof HTMLElement) {
      __p += '\n        ' + ((__t = ctx.t(ctx.prefix.outerHTML, {
        _userInput: true
      })) == null ? '' : __t) + '\n      ';
    } else {
      __p += '\n        ' + ((__t = ctx.t(ctx.prefix, {
        _userInput: true
      })) == null ? '' : __t) + '\n      ';
    }
    __p += '\n    </span>\n    </div>\n  ';
  }
  __p += '\n  ';
  if (!ctx.component.editor && !ctx.component.wysiwyg) {
    __p += '\n    <' + ((__t = ctx.input.type) == null ? '' : __t) + '\n      ref="' + ((__t = ctx.input.ref ? ctx.input.ref : 'input') == null ? '' : __t) + '"\n      ';
    for (var attr in ctx.input.attr) {
      __p += '\n        ' + ((__t = attr) == null ? '' : __t) + '="' + ((__t = ctx.input.attr[attr]) == null ? '' : __t) + '"\n      ';
    }
    __p += '\n      id="' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n      aria-labelledby="l-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + ' ';
    if (ctx.component.description) {
      __p += 'd-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t);
    }
    __p += '"\n      aria-required="' + ((__t = ctx.input.ref === 'input' || !ctx.input.ref ? ctx.component.validate.required : ctx.component.fields && ctx.component.fields[ctx.input.ref] && ctx.component.fields[ctx.input.ref].required || false) == null ? '' : __t) + '"\n    >' + ((__t = ctx.input.content) == null ? '' : __t) + '</' + ((__t = ctx.input.type) == null ? '' : __t) + '>\n    ';
    if (ctx.hasValueMaskInput) {
      __p += '\n      <input ref="valueMaskInput" />\n    ';
    }
    __p += '\n';
  }
  __p += '\n';
  if (ctx.component.editor || ctx.component.wysiwyg) {
    __p += '\n  <div ref="input"></div>\n';
  }
  __p += '\n';
  if (ctx.component.type === 'datetime') {
    __p += '\n<span aria-live="assertive" id="' + ((__t = ctx.instance.id) == null ? '' : __t) + '-liveRegion" class="sr-only" ref="liveRegion"></span>\n';
  }
  __p += '\n';
  if (ctx.suffix) {
    __p += '\n  <div class="input-group-append" ref="suffix">\n    <span class="input-group-text">\n      ';
    if (ctx.suffix instanceof HTMLElement) {
      __p += '\n        ' + ((__t = ctx.t(ctx.suffix.outerHTML, {
        _userInput: true
      })) == null ? '' : __t) + '\n      ';
    } else {
      __p += '\n        ' + ((__t = ctx.t(ctx.suffix, {
        _userInput: true
      })) == null ? '' : __t) + '\n      ';
    }
    __p += '\n    </span>\n  </div>\n';
  }
  __p += '\n';
  if (ctx.prefix || ctx.suffix) {
    __p += '\n  </div>\n';
  }
  __p += '\n';
  if (ctx.component.showCharCount || ctx.component.showWordCount) {
    __p += '\n<div class="form-text ' + ((__t = ctx.component.description ? 'pull-right' : 'text-right') == null ? '' : __t) + '">\n  ';
    if (ctx.component.showCharCount) {
      __p += '\n  <span class="text-muted" ref="charcount" aria-live="polite"></span>\n  ';
    }
    __p += '\n  ';
    if (ctx.component.showWordCount) {
      __p += '\n  <span class="text-muted" ref="wordcount" aria-live="polite"></span>\n  ';
    }
    __p += '\n</div>\n';
  }
  __p += '\n';
  return __p;
}

function html$5 (ctx) {
  var __t,
    __p = '';
  __p += '<div ref="value">';
  if (ctx.value) {
    __p += (__t = ctx.value) == null ? '' : __t;
  } else {
    __p += '-';
  }
  __p += '</div>\n';
  return __p;
}

var input = {
  form: form$w,
  html: html$5
};

function form$v (ctx) {
  var __t,
    __p = '';
  __p += '<label\n  ref="label"\n  class="col-form-label ' + ((__t = ctx.label.className) == null ? '' : __t) + '"\n  for="' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n  id="l-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n>\n  ' + ((__t = ctx.t(ctx.component.label, {
    _userInput: true
  })) == null ? '' : __t) + '\n  ';
  if (ctx.component.type === 'number' || ctx.component.type === 'phoneNumber' || ctx.component.type === 'currency') {
    __p += '\n    <span class=\'sr-only\'>, ' + ((__t = ctx.t('numeric only')) == null ? '' : __t) + ',</span>\n  ';
  }
  __p += '\n  ';
  if (ctx.component.tooltip) {
    __p += '\n    <i ref="tooltip" tabindex="0" class="' + ((__t = ctx.iconClass('question-sign')) == null ? '' : __t) + ' text-muted" data-tooltip="' + ((__t = ctx.component.tooltip) == null ? '' : __t) + '"></i>\n  ';
  }
  __p += '\n</label>\n';
  return __p;
}

var label = {
  form: form$v
};

function form$u (ctx) {
  var __p = '';
  __p += '<div class="formio-loader">\n  <div class="loader-wrapper">\n    <div class="loader text-center"></div>\n  </div> \n</div>\n';
  return __p;
}

var loader = {
  form: form$u
};

function form$t (ctx) {
  var __t,
    __p = '';
  __p += ((__t = ctx.t('Loading')) == null ? '' : __t) + '...\n';
  return __p;
}

var loading = {
  form: form$t
};

function form$s (ctx) {
  var __t,
    __p = '';
  __p += '<div id="' + ((__t = ctx.mapId) == null ? '' : __t) + '" style="min-height: 300px; height: calc(100vh - 600px);" ref="gmapElement"></div>\n';
  return __p;
}

var map = {
  form: form$s
};

function form$r (ctx) {
  var __t,
    __p = '';
  __p += '<div id="e-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.key) == null ? '' : __t) + '" class="form-text ' + ((__t = ctx.level || 'error') == null ? '' : __t) + '">' + ((__t = ctx.message) == null ? '' : __t) + '</div>\n';
  return __p;
}

var message = {
  form: form$r
};

function form$q (ctx) {
  var __t,
    __p = '';
  __p += '<div class="formio-dialog formio-dialog-theme-default formio-modaledit-dialog">\n  <div ref="overlay" class="formio-dialog-overlay"></div>\n  <div ref="content" class="formio-modaledit-content">\n    <button\n      ref="close"\n      type="button"\n      role="button"\n      class="btn btn-primary btn-xs formio-modaledit-close">\n      ' + ((__t = ctx.t('Close')) == null ? '' : __t) + '\n    </button>\n    <div ref="inner" class="reset-margins"></div>\n  </div>\n</div>\n';
  return __p;
}

var modaldialog = {
  form: form$q
};

function form$p (ctx) {
  var __t,
    __p = '';
  __p += '<div ref="container" class="formio-modaledit-view-container">\n  <button\n    ref="edit"\n    type="button"\n    role="button"\n    class="btn btn-xxs btn-warning formio-modaledit-edit">\n    <i class="' + ((__t = ctx.iconClass('edit')) == null ? '' : __t) + '"></i>\n  </button>\n  <div ref="input" class="modaledit-view-inner reset-margins">' + ((__t = ctx.content) == null ? '' : __t) + '</div>\n</div>\n';
  return __p;
}

var modaledit = {
  form: form$p
};

function form$o (ctx) {
  var __t,
    __p = '';
  __p += '<label id="l-' + ((__t = ctx.component.key) == null ? '' : __t) + '" class="control-label ' + ((__t = ctx.label.className) == null ? '' : __t) + '">\n  ' + ((__t = ctx.t(ctx.component.label, {
    _userInput: true
  })) == null ? '' : __t) + '<span ref="modalLabelValue" class="sr-only">. ' + ((__t = ctx.component.type === 'signature' ? ctx.self.getValueAsString(ctx.previewText) : ctx.previewText) == null ? '' : __t) + '</span>\n</label><br>\n<span class="sr-only" ref="modalPreviewLiveRegion" aria-live="assertive"></span>\n<button\n  lang="en"\n  class="btn btn-light btn-md open-modal-button form-control ' + ((__t = ctx.openModalBtnClasses || '') == null ? '' : __t) + '"\n  ref="openModal"\n  aria-labelledby="l-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n>\n  ' + ((__t = ctx.previewText) == null ? '' : __t) + '\n</button>\n<div class="formio-errors invalid-feedback">\n  ' + ((__t = ctx.messages) == null ? '' : __t) + '\n</div>\n';
  return __p;
}

var modalPreview = {
  form: form$o
};

function form$n (ctx) {
  var __t,
    __p = '';
  __p += '<div\n  class="input-group formio-multiple-mask-container"\n  ref="' + ((__t = ctx.input.ref ? ctx.input.ref : 'input') == null ? '' : __t) + '"\n>\n  <select\n    class="form-control formio-multiple-mask-select"\n    id="' + ((__t = ctx.key) == null ? '' : __t) + '-mask"\n    ref="select"\n    ';
  if (ctx.input.attr.disabled) {
    __p += 'disabled';
  }
  __p += '>\n    ';
  ctx.selectOptions.forEach(function (option) {
    __p += '\n    <option value="' + ((__t = option.value) == null ? '' : __t) + '">' + ((__t = option.label) == null ? '' : __t) + '</option>\n    ';
  });
  __p += '\n  </select>\n  <input\n    ref="mask"\n    ';
  for (var attr in ctx.input.attr) {
    __p += '\n    ' + ((__t = attr) == null ? '' : __t) + '="' + ((__t = ctx.input.attr[attr]) == null ? '' : __t) + '"\n    ';
  }
  __p += '\n  >\n</div>\n';
  return __p;
}

var multipleMasksInput = {
  form: form$n
};

function form$m (ctx) {
  var __t,
    __p = '';
  __p += '<tr ref="row">\n  <td>\n    ' + ((__t = ctx.element) == null ? '' : __t) + '\n  </td>\n  ';
  if (!ctx.disabled) {
    __p += '\n  <td>\n    <button type="button" class="btn btn-secondary" ref="removeRow">\n      <i class="' + ((__t = ctx.iconClass('remove-circle')) == null ? '' : __t) + '"></i>\n    </button>\n  </td>\n  ';
  }
  __p += '\n</tr>\n';
  return __p;
}

var multiValueRow = {
  form: form$m
};

function form$l (ctx) {
  var __t,
    __p = '';
  __p += '<table class="table table-bordered">\n  <tbody>\n  ' + ((__t = ctx.rows) == null ? '' : __t) + '\n  ';
  if (!ctx.disabled) {
    __p += '\n  <tr>\n    <td colspan="2">\n      <button class="btn btn-primary formio-button-add-another" ref="addButton"><i class="' + ((__t = ctx.iconClass('plus')) == null ? '' : __t) + '"></i> ' + ((__t = ctx.t(ctx.addAnother, {
      _userInput: true
    })) == null ? '' : __t) + '</button>\n    </td>\n  </tr>\n  ';
  }
  __p += '\n  </tbody>\n</table>\n';
  return __p;
}

var multiValueTable = {
  form: form$l
};

function form$k (ctx) {
  var __t,
    __p = '';
  __p += '<div class="mb-2 card border">\n  ';
  if (!ctx.component.hideLabel || ctx.builder || ctx.component.collapsible || ctx.component.tooltip) {
    __p += '\n  <div class="card-header ' + ((__t = ctx.transform('class', 'bg-' + ctx.component.theme)) == null ? '' : __t) + '"\n    ';
    if (ctx.component.collapsible) {
      __p += '\n    tabindex="0"\n    ';
    }
    __p += '\n    role="button"\n    aria-expanded="' + ((__t = ctx.component.collapsible ? !ctx.collapsed : true) == null ? '' : __t) + '"\n    aria-controls="' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n    ref="header"\n  >\n    <span class="mb-0 card-title ';
    if (ctx.component.theme && ctx.component.theme !== 'default') {
      __p += 'text-light';
    }
    __p += '">\n      ';
    if (ctx.component.collapsible) {
      __p += '\n        <i class="formio-collapse-icon ' + ((__t = ctx.iconClass(ctx.collapsed ? 'plus-square-o' : 'minus-square-o')) == null ? '' : __t) + ' text-muted" data-title="Collapse Panel"></i>\n      ';
    }
    __p += '\n      ';
    if (!ctx.component.hideLabel || ctx.builder) {
      __p += '\n      ' + ((__t = ctx.t(ctx.component.title, {
        _userInput: true
      })) == null ? '' : __t) + '\n      ';
    }
    __p += '\n      ';
    if (ctx.component.tooltip) {
      __p += '\n        <i ref="tooltip" tabindex="0" class="' + ((__t = ctx.iconClass('question-sign')) == null ? '' : __t) + ' text-muted" data-tooltip="' + ((__t = ctx.component.tooltip) == null ? '' : __t) + '"></i>\n      ';
    }
    __p += '\n    </span>\n  </div>\n  ';
  }
  __p += '\n  ';
  if (!ctx.collapsed || ctx.builder) {
    __p += '\n  <div class="card-body" ref="' + ((__t = ctx.nestedKey) == null ? '' : __t) + '" id="' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '">\n    ' + ((__t = ctx.children) == null ? '' : __t) + '\n  </div>\n  ';
  }
  __p += '\n</div>\n';
  return __p;
}

var panel = {
  form: form$k
};

function form$j (ctx) {
  var __t,
    __p = '';
  __p += '<div class="' + ((__t = ctx.classes) == null ? '' : __t) + '" ref="webform">\n	<button data-noattach="true" ref="zoomIn" style="position:absolute;right:10px;top:10px;cursor:pointer;" class="btn btn-default btn-secondary no-disable">\n		<i class="' + ((__t = ctx.iconClass('zoom-in')) == null ? '' : __t) + '"></i>\n	</button>\n	<button data-noattach="true" ref="zoomOut" style="position:absolute;right:10px;top:60px;cursor:pointer;" class="btn btn-default btn-secondary no-disable">\n		<i class="' + ((__t = ctx.iconClass('zoom-out')) == null ? '' : __t) + '"></i>\n	</button>\n  <div data-noattach="true" ref="iframeContainer"></div>\n  ' + ((__t = ctx.submitButton) == null ? '' : __t) + '\n</div>\n';
  return __p;
}

var pdf = {
  form: form$j
};

function form$i (ctx) {
  var __t,
    __p = '';
  __p += '<div class="formio builder grid grid-cols-12 gap-4 formbuilder">\n  <div class="col-span-12 xs:col-span-4 sm:col-span-3 md:col-span-2 formcomponents">\n    ' + ((__t = ctx.sidebar) == null ? '' : __t) + '\n  </div>\n  <div class="col-span-12 xs:col-span-8 sm:col-span-9 md:col-span-10 formarea" ref="form">\n	  <div class="formio-drop-zone" ref="iframeDropzone"></div>\n    ' + ((__t = ctx.form) == null ? '' : __t) + '\n  </div>\n</div>\n';
  return __p;
}

var pdfBuilder = {
  form: form$i
};

function form$h (ctx) {
  var __t,
    __p = '';
  __p += '<div class="pdf-upload formio-component-file">\n  <h3 class="label">' + ((__t = ctx.t('Upload a PDF File')) == null ? '' : __t) + '</h3>\n  <input type="file" style="opacity: 0; position: absolute;" tabindex="-1" accept=".pdf" ref="hiddenFileInputElement">\n  <div class="fileSelector" ref="fileDrop">\n    <span ref="dragDropText">\n      <i class="' + ((__t = ctx.iconClass('cloud-upload')) == null ? '' : __t) + '"></i>' + ((__t = ctx.t('Drop pdf to start, or')) == null ? '' : __t) + ' <a href="#" ref="fileBrowse" class="browse">' + ((__t = ctx.t('browse')) == null ? '' : __t) + '</a>\n    </span>\n    <div class="progress pdf-progress" ref="uploadProgressWrapper" style="display:none;">\n      <div class="progress-bar" ref="uploadProgress" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>\n    </div>\n  </div>\n  <div class="alert alert-danger" ref="uploadError">\n\n  </div>\n</div>\n\n';
  return __p;
}

var pdfBuilderUpload = {
  form: form$h
};

function form$g (ctx) {
  var __t,
    __p = '';
  __p += '<div\n  class="form-radio radio"\n  ref="radioGroup"\n  role="' + ((__t = ctx.component.type === 'selectboxes' ? 'group' : 'radiogroup') == null ? '' : __t) + '"\n  aria-required="' + ((__t = ctx.input.component.validate.required) == null ? '' : __t) + '"\n  aria-labelledby="l-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n  ';
  if (ctx.component.description) {
    __p += '\n    aria-describedby="d-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n  ';
  }
  __p += '\n>\n  ';
  ctx.values.forEach(function (item) {
    __p += '\n  <div class="' + ((__t = ctx.input.attr.type) == null ? '' : __t) + ' ' + ((__t = ctx.component.optionsLabelPosition && ctx.component.optionsLabelPosition !== 'right' ? 'pl-0' : '') == null ? '' : __t) + ' form-check' + ((__t = ctx.inline ? '-inline' : '') == null ? '' : __t) + '" ref="wrapper">\n    <label class="form-check-label label-position-' + ((__t = ctx.component.optionsLabelPosition) == null ? '' : __t) + '" for="' + ((__t = ctx.instance.root && ctx.instance.root.id) == null ? '' : __t) + '-' + ((__t = ctx.id) == null ? '' : __t) + '-' + ((__t = ctx.row) == null ? '' : __t) + '-' + ((__t = item.value) == null ? '' : __t) + '">\n      ';
    if (ctx.component.optionsLabelPosition === 'left' || ctx.component.optionsLabelPosition === 'top') {
      __p += '\n      <span>' + ((__t = ctx.t(item.label, {
        _userInput: true
      })) == null ? '' : __t) + '</span>\n      ';
    }
    __p += '\n      <' + ((__t = ctx.input.type) == null ? '' : __t) + '\n        ref="input"\n        ';
    for (var attr in ctx.input.attr) {
      __p += '\n        ' + ((__t = attr) == null ? '' : __t) + '="' + ((__t = ctx.input.attr[attr]) == null ? '' : __t) + '"\n        ';
    }
    __p += '\n        value="' + ((__t = item.value) == null ? '' : __t) + '"\n        ';
    if (ctx.value && (ctx.value === item.value || typeof ctx.value === 'object' && ctx.value.hasOwnProperty(item.value) && ctx.value[item.value])) {
      __p += '\n          checked=true\n        ';
    }
    __p += '\n        ';
    if (item.disabled) {
      __p += '\n          disabled=true\n        ';
    }
    __p += '\n        id="' + ((__t = ctx.instance.root && ctx.instance.root.id) == null ? '' : __t) + '-' + ((__t = ctx.id) == null ? '' : __t) + '-' + ((__t = ctx.row) == null ? '' : __t) + '-' + ((__t = item.value) == null ? '' : __t) + '"\n        role="' + ((__t = ctx.component.type === 'selectboxes' ? 'checkbox' : 'radio') == null ? '' : __t) + '"\n      >\n      ';
    if (!ctx.component.optionsLabelPosition || ctx.component.optionsLabelPosition === 'right' || ctx.component.optionsLabelPosition === 'bottom') {
      __p += '\n      <span>' + ((__t = ctx.t(item.label, {
        _userInput: true
      })) == null ? '' : __t) + '</span>\n      ';
    }
    __p += '\n    </label>\n  </div>\n  ';
  });
  __p += '\n</div>\n';
  return __p;
}

function html$4 (ctx) {
  var __t,
    __p = '';
  __p += '<div ref="value">\n  ';
  var filtered = ctx.values.filter(function (item) {
    return ctx.value === item.value || typeof ctx.value === 'object' && ctx.value.hasOwnProperty(item.value) && ctx.value[item.value];
  }).map(function (item) {
    return ctx.t(item.label, {
      _userInput: true
    });
  }).join(', ');
  __p += '\n  ' + ((__t = filtered) == null ? '' : __t) + '\n</div>\n';
  return __p;
}

var radio = {
  form: form$g,
  html: html$4
};

function form$f (ctx) {
  var __t,
    __p = '';
  __p += '<table class="table table-bordered">\n  <tbody>\n    <tr>\n      <td>\n        ' + ((__t = ctx.element) == null ? '' : __t) + '\n      </td>\n    </tr>\n    <tr>\n      <td colspan="2">\n        <button class="btn btn-primary formio-button-add-resource" ref="addResource">\n          <i class="' + ((__t = ctx.iconClass('plus')) == null ? '' : __t) + ' mr-1"></i>\n          ' + ((__t = ctx.t(ctx.component.addResourceLabel || 'Add Resource', {
    _userInput: true
  })) == null ? '' : __t) + '\n        </button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n';
  return __p;
}

var resourceAdd = {
  form: form$f
};

function form$e (ctx) {
  var __t,
    __p = '';
  __p += '<select\n  ref="' + ((__t = ctx.input.ref ? ctx.input.ref : 'selectContainer') == null ? '' : __t) + '"\n  ' + ((__t = ctx.input.multiple ? 'multiple' : '') == null ? '' : __t) + '\n  ';
  for (var attr in ctx.input.attr) {
    __p += '\n  ' + ((__t = attr) == null ? '' : __t) + '="' + ((__t = ctx.input.attr[attr]) == null ? '' : __t) + '"\n  ';
  }
  __p += '\n  ';
  if (!ctx.input.attr.id) {
    __p += '\n  id="' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n  ';
  }
  __p += '\n  ';
  if (ctx.component.description) {
    __p += '\n  aria-describedby="d-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '"\n  ';
  }
  __p += '\n  aria-required="' + ((__t = ctx.input.ref === 'selectContainer' || !ctx.input.ref ? ctx.input.component.validate.required : ctx.component.fields[ctx.input.ref].required) == null ? '' : __t) + '"\n>' + ((__t = ctx.selectOptions) == null ? '' : __t) + '</select>\n<input type="text"\n       class="formio-select-autocomplete-input"\n       ref="autocompleteInput"\n       ';
  if (ctx.input.attr.autocomplete) {
    __p += '\n       autocomplete="' + ((__t = ctx.input.attr.autocomplete) == null ? '' : __t) + '"\n       ';
  }
  __p += '\n       tabindex="-1"\n       aria-label="' + ((__t = ctx.t('autocomplete')) == null ? '' : __t) + '"\n/>\n';
  return __p;
}

function html$3 (ctx) {
  var __t,
    __p = '';
  __p += '<div ref="value">';
  if (ctx.value) {
    __p += (__t = ctx.self.itemValueForHTMLMode(ctx.value)) == null ? '' : __t;
  } else {
    __p += '-';
  }
  __p += '</div>\n';
  return __p;
}

var select = {
  form: form$e,
  html: html$3
};

function form$d (ctx) {
  var __t,
    __p = '';
  __p += '<option ' + ((__t = ctx.selected ? 'selected="selected"' : '') == null ? '' : __t) + '\n  value=\'' + ((__t = ctx.useId ? ctx.id : ctx.option.value) == null ? '' : __t) + '\'\n  ';
  for (var attr in ctx.attrs) {
    __p += '\n  ' + ((__t = attr) == null ? '' : __t) + '="' + ((__t = ctx.attrs[attr]) == null ? '' : __t) + '"\n  ';
  }
  __p += '\n  >\n  ' + ((__t = ctx.t(ctx.option.label, {
    _userInput: true
  })) == null ? '' : __t) + '\n</option>\n';
  return __p;
}

function html$2 (ctx) {
  var __t,
    __p = '';
  if (ctx.selected) {
    __p += (__t = ctx.t(ctx.option.label, {
      _userInput: true
    })) == null ? '' : __t;
  }
  __p += '\n';
  return __p;
}

var selectOption = {
  form: form$d,
  html: html$2
};

function form$c (ctx) {
  var __t,
    __p = '';
  __p += ((__t = ctx.element) == null ? '' : __t) + '\n<div\n  class="signature-pad-body"\n  style="width: ' + ((__t = ctx.component.width) == null ? '' : __t) + ';height: ' + ((__t = ctx.component.height) == null ? '' : __t) + ';padding:0;margin:0;"\n  tabindex="' + ((__t = ctx.component.tabindex || 0) == null ? '' : __t) + '"\n  ref="padBody"\n>\n  <button class="btn btn-sm btn-light signature-pad-refresh" ref="refresh">\n    <i class="' + ((__t = ctx.iconClass('refresh')) == null ? '' : __t) + '"></i>\n  </button>\n  <canvas class="signature-pad-canvas" style="display: none;" height="' + ((__t = ctx.component.height) == null ? '' : __t) + '" ref="canvas"></canvas>\n  ';
  if (ctx.required) {
    __p += '\n  <span class="form-control-feedback field-required-inline text-danger">\n    <i class="' + ((__t = ctx.iconClass('asterisk')) == null ? '' : __t) + '"></i>\n  </span>\n  ';
  }
  __p += '\n  <img style="width: 100%;display: inherit;" ref="signatureImage">\n</div>\n';
  if (ctx.component.footer) {
    __p += '\n  <div class="signature-pad-footer">\n    ' + ((__t = ctx.t(ctx.component.footer, {
      _userInput: true
    })) == null ? '' : __t) + '\n  </div>\n';
  }
  __p += '\n';
  return __p;
}

function html$1 (ctx) {
  var __p = '';
  __p += '<img style="width: 100%;" ref="signatureImage">\n';
  return __p;
}

var signature = {
  form: form$c,
  html: html$1
};

function form$b (ctx) {
  var __t,
    __p = '';
  __p += '<table class="table table-striped table-bordered" aria-labelledby="l-' + ((__t = ctx.instance.id) == null ? '' : __t) + '-' + ((__t = ctx.component.key) == null ? '' : __t) + '">\n  <thead>\n    <tr>\n      <th></th>\n      ';
  ctx.component.values.forEach(function (value) {
    __p += '\n      <th style="text-align: center;">\n        ' + ((__t = ctx.t(value.label, {
      _userInput: true
    })) == null ? '' : __t) + '\n        ';
    if (value.tooltip) {
      __p += '\n          <i ref="tooltip" class="' + ((__t = ctx.iconClass('question-sign')) == null ? '' : __t) + ' text-muted" data-tooltip="' + ((__t = value.tooltip) == null ? '' : __t) + '"></i>\n        ';
    }
    __p += '\n      </th>\n      ';
  });
  __p += '\n    </tr>\n  </thead>\n  <tbody>\n    ';
  ctx.component.questions.forEach(function (question) {
    __p += '\n    <tr>\n      <td>\n        ' + ((__t = ctx.t(question.label)) == null ? '' : __t) + '\n        ';
    if (question.tooltip) {
      __p += '\n          <i ref="tooltip" class="' + ((__t = ctx.iconClass('question-sign')) == null ? '' : __t) + ' text-muted" data-tooltip="' + ((__t = question.tooltip) == null ? '' : __t) + '"></i>\n        ';
    }
    __p += '\n      </td>\n      ';
    ctx.component.values.forEach(function (value) {
      __p += '\n      <td style="text-align: center;">\n        <input type="radio" name="' + ((__t = ctx.self.getInputName(question)) == null ? '' : __t) + '" value="' + ((__t = value.value) == null ? '' : __t) + '" id="' + ((__t = ctx.key) == null ? '' : __t) + '-' + ((__t = question.value) == null ? '' : __t) + '-' + ((__t = value.value) == null ? '' : __t) + '" ref="input">\n      </td>\n      ';
    });
    __p += '\n    </tr>\n    ';
  });
  __p += '\n  </tbody>\n</table>\n';
  return __p;
}

function html (ctx) {
  var __t,
    __p = '';
  __p += '<table class="table table-striped table-bordered">\n  <tbody>\n    ';
  ctx.component.questions.forEach(function (question) {
    __p += '\n    <tr>\n      <th>' + ((__t = ctx.t(question.label)) == null ? '' : __t) + '</th>\n      <td>\n      ';
    ctx.component.values.forEach(function (item) {
      __p += '\n        ';
      if (ctx.value && ctx.value.hasOwnProperty(question.value) && ctx.value[question.value] === item.value) {
        __p += '\n          ' + ((__t = ctx.t(item.label)) == null ? '' : __t) + '\n        ';
      }
      __p += '\n      ';
    });
    __p += '\n      </td>\n    </tr>\n    ';
  });
  __p += '\n  </tbody>\n</table>\n';
  return __p;
}

var survey = {
  form: form$b,
  html
};

function flat (ctx) {
  var __t,
    __p = '';
  ctx.component.components.forEach(function (tab, index) {
    __p += '\n  <div class="mb-2 card border">\n    <div class="card-header bg-default">\n      <h4 class="mb-0 card-title">' + ((__t = ctx.t(tab.label, {
      _userInput: true
    })) == null ? '' : __t) + '</h4>\n    </div>\n    <div\n      class="card-body"\n      ref="' + ((__t = ctx.tabKey) == null ? '' : __t) + '"\n    >\n      ' + ((__t = ctx.tabComponents[index]) == null ? '' : __t) + '\n    </div>\n  </div>\n';
  });
  __p += '\n';
  return __p;
}

function form$a (ctx) {
  var __t,
    __p = '';
  __p += '<div class="card card-tabs { ctx.component.verticalLayout ? \' card-vertical\' : \'\'}}">\n  <div class="card-header card-header-tabs">\n    <ul class="nav nav-tabs ' + ((__t = ctx.component.verticalLayout ? ' nav-tabs-vertical' : '') == null ? '' : __t) + '" role="tablist">\n      ';
  ctx.component.components.forEach(function (tab, index) {
    __p += '\n      <li class="nav-item ' + ((__t = ctx.currentTab === index ? ' active' : '') == null ? '' : __t) + '" role="tab" ref="' + ((__t = ctx.tabLikey) == null ? '' : __t) + '">\n        <a\n                class="nav-link' + ((__t = ctx.currentTab === index ? ' active' : '') == null ? '' : __t) + '' + ((__t = ctx.component.verticalLayout ? ' nav-link-vertical' : '') == null ? '' : __t) + '"\n                href="#' + ((__t = tab.key) == null ? '' : __t) + '"\n                ref="' + ((__t = ctx.tabLinkKey) == null ? '' : __t) + '"\n        >\n          ' + ((__t = ctx.t(tab.label, {
      _userInput: true
    })) == null ? '' : __t) + '\n        </a>\n        <div class="nav-border"></div>\n      </li>\n      ';
  });
  __p += '\n    </ul>\n  </div>\n  ';
  ctx.component.components.forEach(function (tab, index) {
    __p += '\n  <div\n    role="tabpanel"\n    class="card-body tab-pane' + ((__t = ctx.currentTab === index ? ' active' : '') == null ? '' : __t) + '"\n    style="display: ' + ((__t = ctx.currentTab === index ? 'block' : 'none') == null ? '' : __t) + '"\n    ref="' + ((__t = ctx.tabKey) == null ? '' : __t) + '"\n  >\n    ' + ((__t = ctx.tabComponents[index]) == null ? '' : __t) + '\n  </div>\n  ';
  });
  __p += '\n</div>\n';
  return __p;
}

var tab = {
  flat,
  form: form$a
};

function form$9 (ctx) {
  var __t,
    __p = '';
  __p += '<table class="table\n    ' + ((__t = ctx.component.striped ? 'table-striped' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.bordered ? 'table-bordered' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.hover ? 'table-hover' : '') == null ? '' : __t) + '\n    ' + ((__t = ctx.component.condensed ? 'table-sm' : '') == null ? '' : __t) + '\n  ">\n  <caption class="sr-only">' + ((__t = ctx.t(ctx.component.label)) == null ? '' : __t) + '</caption>\n  ';
  if (ctx.component.header && ctx.component.header.length > 0) {
    __p += '\n  <thead>\n    <tr>\n      ';
    ctx.component.header.forEach(function (header) {
      __p += '\n      <th>' + ((__t = ctx.t(header)) == null ? '' : __t) + '</th>\n      ';
    });
    __p += '\n    </tr>\n  </thead>\n  ';
  }
  __p += '\n  <tbody>\n    ';
  ctx.tableComponents.forEach(function (row, rowIndex) {
    __p += '\n    <tr ref="row-' + ((__t = ctx.id) == null ? '' : __t) + '">\n      ';
    row.forEach(function (column, colIndex) {
      __p += '\n      <td ref="' + ((__t = ctx.tableKey) == null ? '' : __t) + '-' + ((__t = rowIndex) == null ? '' : __t) + '"';
      if (ctx.cellClassName) {
        __p += ' class="' + ((__t = ctx.cellClassName) == null ? '' : __t) + '"';
      }
      __p += '>' + ((__t = column) == null ? '' : __t) + '</td>\n      ';
    });
    __p += '\n    </tr>\n    ';
  });
  __p += '\n  </tbody>\n</table>\n';
  return __p;
}

var table = {
  form: form$9
};

function form$8 (ctx) {
  var __t,
    __p = '';
  ctx.children.forEach(function (component) {
    __p += '\n  <td class="editgrid-table-column">\n    ' + ((__t = component) == null ? '' : __t) + '\n  </td>\n';
  });
  __p += '\n';
  return __p;
}

var tableComponents = {
  form: form$8
};

function form$7 (ctx) {
  var __t,
    __p = '';
  if (ctx.node.isRoot) {
    __p += '\n  <div ref="root" class="list-group-item">\n';
  } else {
    __p += '\n  <li ref="node" class="list-group-item sm:col-span-12 tree__level tree__level_' + ((__t = ctx.odd ? 'odd' : 'even') == null ? '' : __t) + '">\n';
  }
  __p += '\n  ';
  if (ctx.content) {
    __p += '\n    <div ref="content" class="tree__node-content">\n      ' + ((__t = ctx.content) == null ? '' : __t) + '\n    </div>\n  ';
  }
  __p += '\n  ';
  if (ctx.childNodes && ctx.childNodes.length) {
    __p += '\n    <ul ref="childNodes" class="tree__node-children list-group grid grid-cols-12 gap-4">\n      ' + ((__t = ctx.childNodes.join('')) == null ? '' : __t) + '\n    </ul>\n  ';
  }
  __p += '\n';
  if (ctx.node.isRoot) {
    __p += '\n  </div>\n';
  } else {
    __p += '\n  </li>\n';
  }
  __p += '\n';
  return __p;
}

var tree = {
  form: form$7
};

function edit (ctx) {
  var __t,
    __p = '';
  __p += '<div class="node-edit">\n  <div ref="nodeEdit">' + ((__t = ctx.children) == null ? '' : __t) + '</div>\n  ';
  if (!ctx.readOnly) {
    __p += '\n    <div class="node-actions">\n      <button ref="saveNode" class="btn btn-primary saveNode">' + ((__t = ctx.t('Save')) == null ? '' : __t) + '</button>\n      <button ref="cancelNode" class="btn btn-danger cancelNode">' + ((__t = ctx.t('Cancel')) == null ? '' : __t) + '</button>\n    </div>\n  ';
  }
  __p += '\n</div>\n';
  return __p;
}

function view (ctx) {
  var __t,
    __p = '';
  __p += '<div class="grid grid-cols-12 gap-4">\n  ';
  ctx.values.forEach(function (value) {
    __p += '\n    <div class="sm:col-span-2">\n      ' + ((__t = value) == null ? '' : __t) + '\n    </div>\n  ';
  });
  __p += '\n  <div class="sm:col-span-3">\n    <div class="btn-group pull-right">\n      ';
  if (ctx.node.hasChildren) {
    __p += '\n        <button ref="toggleNode" class="btn btn-default btn-sm toggleNode">' + ((__t = ctx.t(ctx.node.collapsed ? 'Expand' : 'Collapse')) == null ? '' : __t) + '</button>\n      ';
  }
  __p += '\n      ';
  if (!ctx.readOnly) {
    __p += '\n        <button ref="addChild" class="btn btn-default btn-sm addChild">' + ((__t = ctx.t('Add')) == null ? '' : __t) + '</button>\n        <button ref="editNode" class="btn btn-default btn-sm editNode">' + ((__t = ctx.t('Edit')) == null ? '' : __t) + '</button>\n        <button ref="removeNode" class="btn btn-danger btn-sm removeNode">' + ((__t = ctx.t('Delete')) == null ? '' : __t) + '</button>\n        ';
    if (ctx.node.revertAvailable) {
      __p += '\n          <button ref="revertNode" class="btn btn-danger btn-sm revertNode">' + ((__t = ctx.t('Revert')) == null ? '' : __t) + '</button>\n        ';
    }
    __p += '\n      ';
  }
  __p += '\n    </div>\n  </div>\n</div>\n';
  return __p;
}

var treePartials = {
  treeView: {
    form: view
  },
  treeEdit: {
    form: edit
  }
};

function builder$1 (ctx) {
  var __t,
    __p = '';
  __p += '<div class="text-muted text-center p-2">' + ((__t = ctx.t(ctx.component.title, {
    _userInput: true
  })) == null ? '' : __t) + '</div>\n';
  return __p;
}

function form$6 (ctx) {
  var __t,
    __p = '';
  __p += '<div class="' + ((__t = ctx.classes) == null ? '' : __t) + '" ref="webform" novalidate>' + ((__t = ctx.children) == null ? '' : __t) + '</div>\n';
  return __p;
}

var webform = {
  form: form$6,
  builder: builder$1
};

function form$5 (ctx) {
  var __t,
    __p = '';
  __p += '<div class="border-1 border-solid border-gray-300 bg-gray-200 shadow-inner p-5 rounded">\n  <div ref="' + ((__t = ctx.nestedKey) == null ? '' : __t) + '">\n    ' + ((__t = ctx.children) == null ? '' : __t) + '\n  </div>\n</div>\n';
  return __p;
}

var well = {
  form: form$5
};

function builder (ctx) {
  var __t,
    __p = '';
  __p += '<div class="text-muted text-center p-2">' + ((__t = ctx.t(ctx.component.title, {
    _userInput: true
  })) == null ? '' : __t) + '</div>\n';
  return __p;
}

function form$4 (ctx) {
  var __t,
    __p = '';
  __p += '<div class="' + ((__t = ctx.className) == null ? '' : __t) + '">\n    <div style="position: relative;">\n        ';
  if (ctx.wizardHeaderType === 'wizardHeaderVertical') {
    __p += '\n        <div class="row">\n            ';
    if (ctx.wizardHeaderLocation !== 'right') {
      __p += '\n            <div class="col-sm-2">\n                ' + ((__t = ctx.wizardHeader) == null ? '' : __t) + '\n            </div>\n            ';
    }
    __p += '\n            <div class="wizard-page col-sm-10" ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '">\n                ' + ((__t = ctx.components) == null ? '' : __t) + '\n            </div>\n            ';
    if (ctx.wizardHeaderLocation === 'right') {
      __p += '\n            <div class="col-sm-2">\n                ' + ((__t = ctx.wizardHeader) == null ? '' : __t) + '\n            </div>\n            ';
    }
    __p += '\n        </div>\n        <div class="col-sm-offset-2 col-sm-10 ' + ((__t = ctx.wizardHeaderLocation === 'right' ? 'col-sm-offset-0 col-md-offset-0' : '') == null ? '' : __t) + '">\n            ' + ((__t = ctx.wizardNav) == null ? '' : __t) + '\n        </div>\n        ';
  } else {
    __p += '\n        ' + ((__t = ctx.wizardHeader) == null ? '' : __t) + '\n        <div class="wizard-page" ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '">\n            ' + ((__t = ctx.components) == null ? '' : __t) + '\n        </div>\n        ' + ((__t = ctx.wizardNav) == null ? '' : __t) + '\n        ';
  }
  __p += '\n    </div>\n</div>\n';
  return __p;
}

var wizard = {
  form: form$4,
  builder
};

function form$3 (ctx) {
  var __t,
    __p = '';
  __p += '<nav aria-label="Wizard navigation" id="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-header" ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-header">\n  <ul class="pagination" role="tablist">\n    ';
  ctx.panels.forEach(function (panel, index) {
    __p += '\n    <li class="page-item' + ((__t = ctx.currentPage === index ? ' active' : '') == null ? '' : __t) + '" style="cursor: pointer;">\n      <button tabindex="0" data-index="' + ((__t = index) == null ? '' : __t) + '" role="tab" class="page-link" ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-link">\n        ' + ((__t = ctx.t(panel.title, {
      _userInput: true
    })) == null ? '' : __t) + '\n        ';
    if (panel.tooltip && ctx.currentPage === index) {
      __p += '\n        <i ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-tooltip" class="' + ((__t = ctx.iconClass('question-sign')) == null ? '' : __t) + ' text-muted" data-tooltip="' + ((__t = panel.tooltip) == null ? '' : __t) + '"></i>\n        ';
    }
    __p += '\n      </button>\n    </li>\n    ';
  });
  __p += '\n  </ul>\n</nav>\n';
  return __p;
}

var wizardHeader = {
  form: form$3
};

function form$2 (ctx) {
  var __t,
    __p = '';
  __p += '<nav aria-label="navigation" id="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-header">\n  <div class="classic-pagination row justify-content-center" style="border-bottom:0;">\n    ';
  ctx.panels.forEach(function (panel, index) {
    __p += '\n      <div class="classic-pagination-page col-xs-12 col-sm-6 col-md-3\n          ' + ((__t = ctx.currentPage < index ? ' disabled' : '') == null ? '' : __t) + '\n          ' + ((__t = ctx.currentPage === index ? ' active' : '') == null ? '' : __t) + '\n          ' + ((__t = ctx.currentPage > index ? ' complete' : '') == null ? '' : __t) + '">\n        <div class="text-center classic-pagination-title">' + ((__t = ctx.t(panel.title, {
      _userInput: true
    })) == null ? '' : __t) + '</div>\n        ';
    if (ctx.panels.length > 1) {
      __p += '\n          <div class="progress"><div class="progress-bar"></div></div>\n        ';
    }
    __p += ' \n        <span ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-link" class="classic-pagination-dot"></span>\n      </div>\n    ';
  });
  __p += '\n  </div>\n</nav>\n';
  return __p;
}

var wizardHeaderClassic = {
  form: form$2
};

function form$1 (ctx) {
  var __t,
    __p = '';
  __p += '<nav aria-label="navigation" id="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-header">\n  <ul class="pagination flex-column">\n    ';
  ctx.panels.forEach(function (panel, index) {
    __p += '\n    <li class="col-xs-12 page-item' + ((__t = ctx.currentPage === index ? ' active' : '') == null ? '' : __t) + '" style="cursor: pointer;">\n      <span class="page-link" ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-link" style="margin-left: 0px;">\n        ' + ((__t = ctx.t(panel.title, {
      _userInput: true
    })) == null ? '' : __t) + '\n        ';
    if (panel.tooltip && ctx.currentPage === index) {
      __p += '\n        <i ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-tooltip" class="' + ((__t = ctx.iconClass('question-sign')) == null ? '' : __t) + ' text-muted" data-tooltip="' + ((__t = panel.tooltip) == null ? '' : __t) + '"></i>\n        ';
    }
    __p += '\n      </span>\n    </li>\n    ';
  });
  __p += '\n  </ul>\n</nav>\n';
  return __p;
}

var wizardHeaderVertical = {
  form: form$1
};

function form (ctx) {
  var __t,
    __p = '';
  __p += '<ul class="formio-wizard-nav-container list-inline" id="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-nav">\n  ';
  ctx.buttonOrder.forEach(function (button) {
    __p += '\n    ';
    if (button === 'cancel' && ctx.buttons.cancel) {
      __p += '\n    <li>\n      <button class="btn btn-secondary btn-wizard-nav-cancel" ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-cancel" aria-label="' + ((__t = ctx.t('cancelButtonAriaLabel')) == null ? '' : __t) + '">' + ((__t = ctx.t('cancel')) == null ? '' : __t) + '</button>\n    </li>\n    ';
    }
    __p += '\n    ';
    if (button === 'previous' && ctx.buttons.previous) {
      __p += '\n    <li>\n      <button class="btn btn-primary btn-wizard-nav-previous" ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-previous" aria-label="' + ((__t = ctx.t('previousButtonAriaLabel')) == null ? '' : __t) + '">' + ((__t = ctx.t('previous')) == null ? '' : __t) + '</button>\n    </li>\n    ';
    }
    __p += '\n    ';
    if (button === 'next' && ctx.buttons.next) {
      __p += '\n    <li>\n      <button class="btn btn-primary btn-wizard-nav-next" ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-next" aria-label="' + ((__t = ctx.t('nextButtonAriaLabel')) == null ? '' : __t) + '">' + ((__t = ctx.t('next')) == null ? '' : __t) + '</button>\n    </li>\n    ';
    }
    __p += '\n    ';
    if (button === 'submit' && ctx.buttons.submit) {
      __p += '\n    <li>\n      ';
      if (ctx.disableWizardSubmit) {
        __p += '\n      <button disabled class="btn btn-primary btn-wizard-nav-submit" ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-submit" aria-label="' + ((__t = ctx.t('submitButtonAriaLabel')) == null ? '' : __t) + '">' + ((__t = ctx.t('submit')) == null ? '' : __t) + '</button>\n      ';
      } else {
        __p += '\n      <button class="btn btn-primary btn-wizard-nav-submit" ref="' + ((__t = ctx.wizardKey) == null ? '' : __t) + '-submit" aria-label="' + ((__t = ctx.t('submitButtonAriaLabel')) == null ? '' : __t) + '">' + ((__t = ctx.t('submit')) == null ? '' : __t) + '</button>\n      ';
      }
      __p += '\n    </li>\n    ';
    }
    __p += '\n  ';
  });
  __p += '\n</ul>\n';
  return __p;
}

var wizardNav = {
  form
};

var tailwind = _extends({
  ICONS,
  transform(type, text) {
    if (!text) {
      return text;
    }
    switch (type) {
      case "class":
        // eslint-disable-next-line no-prototype-builtins
        return this.cssClasses.hasOwnProperty(text.toString()) ? this.cssClasses[text.toString()] : text;
    }
    return text;
  },
  defaultIconset: "bx",
  iconClass,
  cssClasses,
  address,
  builder: builder$2,
  builderComponent,
  builderComponents,
  builderEditForm,
  builderPlaceholder,
  builderSidebar,
  builderSidebarGroup,
  builderWizard,
  button,
  checkbox,
  columns,
  component,
  componentModal,
  components,
  tableComponents,
  container,
  datagrid,
  day,
  dialog,
  editgrid,
  editgridTable,
  field,
  fieldset,
  file,
  html: html$6,
  icon,
  input,
  label,
  loader,
  loading,
  map,
  message,
  modaledit,
  modaldialog,
  modalPreview,
  multipleMasksInput,
  multiValueRow,
  multiValueTable,
  panel,
  pdf,
  pdfBuilder,
  pdfBuilderUpload,
  radio,
  resourceAdd,
  select,
  selectOption,
  signature,
  survey,
  tab,
  table,
  tree
}, treePartials, {
  webform,
  well,
  wizard,
  wizardHeader,
  wizardHeaderClassic,
  wizardHeaderVertical,
  wizardNav,
  errorsList,
  alert
});

var templates = {
  tailwind
};

var index = {
  framework: "tailwind",
  templates
};

export { index as default };
//# sourceMappingURL=index.modern.js.map
